import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActivityLogEntryDto = {
  __typename?: 'ActivityLogEntryDTO';
  action: Scalars['String']['output'];
  changes: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityType: Scalars['String']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  performedBy: ActivityLogUserDto;
  summary: Scalars['String']['output'];
};

export type ActivityLogUserDto = {
  __typename?: 'ActivityLogUserDTO';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type AssignEventItemMaterialInputDto = {
  masterMaterialId: Scalars['UUID']['input'];
  materialQty?: InputMaybe<Scalars['Float']['input']>;
  materialUnit?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignEventItemVendorInputDto = {
  counterCount?: InputMaybe<Scalars['Float']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventItemId?: InputMaybe<Scalars['UUID']['input']>;
  itemQty?: InputMaybe<Scalars['Float']['input']>;
  itemUnit?: InputMaybe<Scalars['String']['input']>;
  masterItemId?: InputMaybe<Scalars['UUID']['input']>;
  materials?: InputMaybe<Array<AssignEventItemMaterialInputDto>>;
  scopeOfWork?: InputMaybe<ScopeOfWorkEnum>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  serviceTime?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignEventItemVendorResponseDto = {
  __typename?: 'AssignEventItemVendorResponseDTO';
  eventItemId?: Maybe<Scalars['UUID']['output']>;
  operationInfo: OperationInfo;
};

export type AuthPayloadDto = {
  __typename?: 'AuthPayloadDTO';
  branches: Array<BranchDto>;
  permissions: Scalars['JSONObject']['output'];
  token: Scalars['String']['output'];
  user: UserDto;
};

export type BaseResponse = {
  __typename?: 'BaseResponse';
  operationInfo: OperationInfo;
};

export type BranchDto = {
  __typename?: 'BranchDTO';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type BranchesResponseDto = {
  __typename?: 'BranchesResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type BulkAssignEventItemDto = {
  counterCount?: InputMaybe<Scalars['Float']['input']>;
  eventItemId: Scalars['UUID']['input'];
};

export type BulkAssignEventItemVendorInputDto = {
  eventId: Scalars['UUID']['input'];
  itemQty?: InputMaybe<Scalars['Float']['input']>;
  itemUnit?: InputMaybe<Scalars['String']['input']>;
  items: Array<BulkAssignEventItemDto>;
  scopeOfWork: ScopeOfWorkEnum;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  serviceTime?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['UUID']['input'];
};

export type BulkAssignMaterialVendorInputDto = {
  eventId: Scalars['UUID']['input'];
  masterMaterialIds: Array<Scalars['UUID']['input']>;
  vendorId: Scalars['UUID']['input'];
};

export type BulkSetMasterItemVendorsInputDto = {
  addVendorId: Scalars['UUID']['input'];
  masterItemIds: Array<Scalars['UUID']['input']>;
};

export type BulkSetMasterMaterialVendorsInputDto = {
  addVendorId: Scalars['UUID']['input'];
  materialIds: Array<Scalars['UUID']['input']>;
};

/** Category type enum */
export enum CategoryTypeEnum {
  Material = 'MATERIAL',
  MenuItem = 'MENU_ITEM'
}

export type ClientDto = {
  __typename?: 'ClientDTO';
  clientCode: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  settings: Scalars['JSON']['output'];
  status: ClientStatusEnum;
};

/** Client status enum */
export enum ClientStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export type CreateBranchInputDto = {
  name: Scalars['String']['input'];
};

export type CreateEventInputDto = {
  events: Array<EventInputDto>;
  orderId: Scalars['UUID']['input'];
};

export type CreateEventResponseDto = {
  __typename?: 'CreateEventResponseDTO';
  operationInfo: OperationInfo;
};

export type CreateEventTemplateInputDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rate?: InputMaybe<Scalars['Int']['input']>;
  suggestionCriteria?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CreateMasterCategoryGroupInputDto = {
  name: Scalars['String']['input'];
  type: CategoryTypeEnum;
};

export type CreateMasterCategoryInputDto = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  showCategoryLabel?: InputMaybe<Scalars['Boolean']['input']>;
  type: CategoryTypeEnum;
};

export type CreateMasterItemInputDto = {
  defaultExtraRate?: InputMaybe<Scalars['Float']['input']>;
  defaultExtraUnit?: InputMaybe<Scalars['String']['input']>;
  isExtraByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExtraChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  masterCategoryId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  vendorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateMasterMaterialInputDto = {
  masterCategoryId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  vendorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateOrderInputDto = {
  customer: CustomerInputDto;
  events: Array<EventInputDto>;
  name: Scalars['String']['input'];
};

export type CreateOrderResponseDto = {
  __typename?: 'CreateOrderResponseDTO';
  customerId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  operationInfo: OperationInfo;
};

export type CreateVendorInputDto = {
  contactNo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
};

export type CustomerBasicDto = {
  __typename?: 'CustomerBasicDTO';
  address?: Maybe<Scalars['String']['output']>;
  contactNo: Scalars['PhoneNumber']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type CustomerDto = {
  __typename?: 'CustomerDTO';
  address?: Maybe<Scalars['String']['output']>;
  contactNo: Scalars['PhoneNumber']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  totalOrders?: Maybe<Scalars['Int']['output']>;
};

export type CustomerInputDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactNo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerWithOrders = {
  __typename?: 'CustomerWithOrders';
  address?: Maybe<Scalars['String']['output']>;
  contactNo: Scalars['PhoneNumber']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  orders: Array<OrderBasicDto>;
};

export type CustomersDto = {
  __typename?: 'CustomersDTO';
  edges: Array<CustomerDto>;
  pageInfo: PageInfo;
};

export type CustomersFiltersInputDto = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type EventInputDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pax?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  time: Scalars['String']['input'];
};

export type EventItemFlatDto = {
  __typename?: 'EventItemFlatDTO';
  alternativeGroupId?: Maybe<Scalars['UUID']['output']>;
  category: MasterCategoryBasicDto;
  extraQty?: Maybe<Scalars['Float']['output']>;
  extraRate?: Maybe<Scalars['Float']['output']>;
  groupPickCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isExtra: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  masterItem: MasterItemBasicDto;
};

export type EventItemInputDto = {
  alternativeGroupId?: InputMaybe<Scalars['UUID']['input']>;
  extraQty?: InputMaybe<Scalars['Float']['input']>;
  extraRate?: InputMaybe<Scalars['Float']['input']>;
  groupPickCount?: InputMaybe<Scalars['Int']['input']>;
  isExtra?: InputMaybe<Scalars['Boolean']['input']>;
  masterItemId: Scalars['UUID']['input'];
};

export type EventItemMaterialFlatDto = {
  __typename?: 'EventItemMaterialFlatDTO';
  id?: Maybe<Scalars['UUID']['output']>;
  itemQty?: Maybe<Scalars['Float']['output']>;
  itemUnit?: Maybe<Scalars['String']['output']>;
  masterMaterial: MasterMaterialBasicDto;
  materialCategory: MasterCategoryBasicDto;
  materialQty?: Maybe<Scalars['Float']['output']>;
  materialUnit?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<EventItemMaterialVendorDto>;
};

export type EventItemMaterialVendorDto = {
  __typename?: 'EventItemMaterialVendorDTO';
  contactNo: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
  vendorId: Scalars['UUID']['output'];
};

export type EventItemPdfEventDto = {
  __typename?: 'EventItemPDFEventDTO';
  eventId: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type EventItemVendorDto = {
  __typename?: 'EventItemVendorDTO';
  contactNo: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
  vendorId: Scalars['UUID']['output'];
};

export type EventItemWithMaterialsFlatDto = {
  __typename?: 'EventItemWithMaterialsFlatDTO';
  alternativeGroupId?: Maybe<Scalars['UUID']['output']>;
  category: MasterCategoryBasicDto;
  counterCount?: Maybe<Scalars['Float']['output']>;
  extraQty?: Maybe<Scalars['Float']['output']>;
  extraRate?: Maybe<Scalars['Float']['output']>;
  groupPickCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isExtra: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  itemQty?: Maybe<Scalars['Float']['output']>;
  itemUnit?: Maybe<Scalars['String']['output']>;
  masterItem: MasterItemBasicDto;
  materials: Array<EventItemMaterialFlatDto>;
  scopeOfWork?: Maybe<ScopeOfWorkEnum>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  serviceTime?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<EventItemVendorDto>;
};

export type EventItemsLabelsPdfGenerationInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
};

export type EventItemsLabelsPdfResponseDto = {
  __typename?: 'EventItemsLabelsPDFResponseDTO';
  filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type EventReportVendorDto = {
  __typename?: 'EventReportVendorDTO';
  contactNo?: Maybe<Scalars['String']['output']>;
  eventIds: Array<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
};

export type EventTemplateDto = {
  __typename?: 'EventTemplateDTO';
  categories: Array<EventTemplateItemsByCategoryDto>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rate?: Maybe<Scalars['Int']['output']>;
  suggestionCriteria?: Maybe<Scalars['JSONObject']['output']>;
};

export type EventTemplateItemDto = {
  __typename?: 'EventTemplateItemDTO';
  alternativeGroupId?: Maybe<Scalars['UUID']['output']>;
  groupPickCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  masterItem?: Maybe<MasterItemBasicDto>;
};

export type EventTemplateItemInputDto = {
  alternativeGroupId?: InputMaybe<Scalars['UUID']['input']>;
  groupPickCount?: InputMaybe<Scalars['Int']['input']>;
  masterItemId: Scalars['UUID']['input'];
};

export type EventTemplateItemsByCategoryDto = {
  __typename?: 'EventTemplateItemsByCategoryDTO';
  masterCategory: MasterCategoryBasicDto;
  templateItems: Array<EventTemplateItemDto>;
};

export type EventTemplatePdfGenerationInputDto = {
  includeIngredients?: Scalars['Boolean']['input'];
  templateId: Scalars['UUID']['input'];
};

export type EventTemplatePdfResponseDto = {
  __typename?: 'EventTemplatePDFResponseDTO';
  filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type EventTemplateResponseDto = {
  __typename?: 'EventTemplateResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type EventTemplateSummaryDto = {
  __typename?: 'EventTemplateSummaryDTO';
  categoryCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rate?: Maybe<Scalars['Int']['output']>;
  suggestionCriteria?: Maybe<Scalars['JSONObject']['output']>;
};

export type EventWithItemsAndMaterialsDto = {
  __typename?: 'EventWithItemsAndMaterialsDTO';
  address?: Maybe<Scalars['String']['output']>;
  customer: CustomerBasicDto;
  date: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  items: Array<EventItemWithMaterialsFlatDto>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: OrderBasicDto;
  pax?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  status: OrderEventStatusEnum;
  time: Scalars['String']['output'];
};

export type EventWithItemsCountDto = {
  __typename?: 'EventWithItemsCountDTO';
  address?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pax?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  status: OrderEventStatusEnum;
  time: Scalars['String']['output'];
  totalMenuItems: Scalars['Int']['output'];
};

export type EventWithItemsDto = {
  __typename?: 'EventWithItemsDTO';
  address?: Maybe<Scalars['String']['output']>;
  customer: CustomerBasicDto;
  date: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  items: Array<EventItemFlatDto>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: OrderBasicDto;
  pax?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  status: OrderEventStatusEnum;
  time: Scalars['String']['output'];
};

export type EventWithOrderDto = {
  __typename?: 'EventWithOrderDTO';
  address?: Maybe<Scalars['String']['output']>;
  customer: CustomerBasicDto;
  date: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  itemsCount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: OrderBasicDto;
  pax?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  status: OrderEventStatusEnum;
  time: Scalars['String']['output'];
};

export type EventsDto = {
  __typename?: 'EventsDTO';
  edges: Array<EventWithOrderDto>;
  pageInfo: PageInfo;
};

export type EventsFiltersInputDto = {
  date: Scalars['String']['input'];
};

export type EventsItemsPdfGenerationInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
  includeIngredients: Scalars['Boolean']['input'];
  includeRate: Scalars['Boolean']['input'];
};

export type EventsItemsPdfResponseDto = {
  __typename?: 'EventsItemsPDFResponseDTO';
  events: Array<EventItemPdfEventDto>;
  totalEvents: Scalars['Float']['output'];
};

export type GenerateMaterialVendorReportsInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
  vendors: Array<MaterialVendorInfoInputDto>;
};

export type GenerateMenuItemVendorReportsInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
  vendorIds: Array<Scalars['UUID']['input']>;
};

export type LoginInputDto = {
  contactNo: Scalars['PhoneNumber']['input'];
  password: Scalars['String']['input'];
};

export type ManagerEventsPdfGenerationInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
};

export type MasterCategoryBasicDto = {
  __typename?: 'MasterCategoryBasicDTO';
  groupId?: Maybe<Scalars['UUID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isInternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  showCategoryLabel: Scalars['Boolean']['output'];
  type: CategoryTypeEnum;
};

export type MasterCategoryGroupDto = {
  __typename?: 'MasterCategoryGroupDTO';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  type: CategoryTypeEnum;
};

export type MasterCategoryGroupResponseDto = {
  __typename?: 'MasterCategoryGroupResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type MasterCategoryResponseDto = {
  __typename?: 'MasterCategoryResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type MasterItemBasicDto = {
  __typename?: 'MasterItemBasicDTO';
  defaultExtraRate?: Maybe<Scalars['Float']['output']>;
  defaultExtraUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isExtraByDefault: Scalars['Boolean']['output'];
  isExtraChargeable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterItemDto = {
  __typename?: 'MasterItemDTO';
  category: MasterCategoryBasicDto;
  defaultExtraRate?: Maybe<Scalars['Float']['output']>;
  defaultExtraUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isExtraByDefault: Scalars['Boolean']['output'];
  isExtraChargeable: Scalars['Boolean']['output'];
  materialCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterItemDetailDto = {
  __typename?: 'MasterItemDetailDTO';
  defaultExtraRate?: Maybe<Scalars['Float']['output']>;
  defaultExtraUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isExtraByDefault: Scalars['Boolean']['output'];
  isExtraChargeable: Scalars['Boolean']['output'];
  masterItemCategory: MasterCategoryBasicDto;
  masterMaterialCategories: Array<MasterItemMaterialCategoryDto>;
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterItemMaterialCategoryDto = {
  __typename?: 'MasterItemMaterialCategoryDTO';
  groupId?: Maybe<Scalars['UUID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isInternal: Scalars['Boolean']['output'];
  masterMaterials: Array<MasterItemMaterialDto>;
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  showCategoryLabel: Scalars['Boolean']['output'];
  type: CategoryTypeEnum;
};

export type MasterItemMaterialDto = {
  __typename?: 'MasterItemMaterialDTO';
  category?: Maybe<MasterCategoryBasicDto>;
  id: Scalars['UUID']['output'];
  isVisibleToCustomer: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterItemMaterialInputDto = {
  isVisibleToCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  masterMaterialId: Scalars['UUID']['input'];
};

export type MasterItemResponseDto = {
  __typename?: 'MasterItemResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type MasterMaterialBasicDto = {
  __typename?: 'MasterMaterialBasicDTO';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterMaterialCategoryDto = {
  __typename?: 'MasterMaterialCategoryDTO';
  groupId?: Maybe<Scalars['UUID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isInternal: Scalars['Boolean']['output'];
  masterMaterials: Array<MasterMaterialBasicDto>;
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  showCategoryLabel: Scalars['Boolean']['output'];
  type: CategoryTypeEnum;
};

export type MasterMaterialDto = {
  __typename?: 'MasterMaterialDTO';
  category: MasterCategoryBasicDto;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  vendors?: Maybe<Array<VendorDto>>;
};

export type MasterMaterialResponseDto = {
  __typename?: 'MasterMaterialResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type MaterialVendorInfoInputDto = {
  address: Scalars['String']['input'];
  date: Scalars['String']['input'];
  time: Scalars['String']['input'];
  vendorId: Scalars['UUID']['input'];
};

export type MaterialVendorReportResponseDto = {
  __typename?: 'MaterialVendorReportResponseDTO';
  totalVendors: Scalars['Float']['output'];
  vendors: Array<VendorPdfItemDto>;
};

export type MaterialsEventsPdfGenerationInputDto = {
  eventIds: Array<Scalars['UUID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  assignEventItemVendor: AssignEventItemVendorResponseDto;
  bulkAssignEventItemVendor: OperationInfo;
  bulkAssignMaterialVendor: BaseResponse;
  bulkSetMasterItemDefaults: MasterItemResponseDto;
  bulkSetMasterMaterialDefaults: MasterMaterialResponseDto;
  createBranch: BranchesResponseDto;
  createEvent: CreateEventResponseDto;
  createEventTemplate: EventTemplateResponseDto;
  createMasterCategory: MasterCategoryResponseDto;
  createMasterCategoryGroup: MasterCategoryGroupResponseDto;
  createMasterItem: MasterItemResponseDto;
  createMasterMaterial: MasterMaterialResponseDto;
  createOrder: CreateOrderResponseDto;
  createVendor: VendorResponseDto;
  deleteEventTemplate: EventTemplateResponseDto;
  deleteMasterCategoryGroup: MasterCategoryGroupResponseDto;
  generateEventItemsLabelsPDF: EventItemsLabelsPdfResponseDto;
  generateEventTemplatePDF: EventTemplatePdfResponseDto;
  generateEventsItemsMaterialsPDF: EventsItemsPdfResponseDto;
  generateEventsItemsPDF: EventsItemsPdfResponseDto;
  generateManagerEventsPDF: EventsItemsPdfResponseDto;
  generateMaterialVendorReports: MaterialVendorReportResponseDto;
  generateMenuItemVendorReports: VendorAssignmentReportResponseDto;
  login: AuthPayloadDto;
  logout: Scalars['Boolean']['output'];
  setEventItems: SetEventItemResponseDto;
  setEventTemplateItems: EventTemplateResponseDto;
  setMasterItemMaterials: MasterItemResponseDto;
  updateBranch: BranchesResponseDto;
  updateEvent: UpdateEventResponseDto;
  updateEventItemMaterialQuantities: BaseResponse;
  updateEventStatus: UpdateEventStatusResponseDto;
  updateEventTemplate: EventTemplateResponseDto;
  updateMasterCategory: MasterCategoryResponseDto;
  updateMasterCategoryGroup: MasterCategoryGroupResponseDto;
  updateMasterCategorySequence: SequenceUpdateMasterItemResponseDto;
  updateMasterItem: MasterItemResponseDto;
  updateMasterItemSequence: SequenceUpdateMasterItemResponseDto;
  updateMasterMaterial: MasterMaterialResponseDto;
  updateMasterMaterialSequence: SequenceUpdateMasterItemResponseDto;
  updateOrder: UpdateOrderResponseDto;
  updateOrderStatus: UpdateOrderStatusResponseDto;
  updateVendor: VendorResponseDto;
};


export type MutationAssignEventItemVendorArgs = {
  input: AssignEventItemVendorInputDto;
};


export type MutationBulkAssignEventItemVendorArgs = {
  input: BulkAssignEventItemVendorInputDto;
};


export type MutationBulkAssignMaterialVendorArgs = {
  input: BulkAssignMaterialVendorInputDto;
};


export type MutationBulkSetMasterItemDefaultsArgs = {
  input: BulkSetMasterItemVendorsInputDto;
};


export type MutationBulkSetMasterMaterialDefaultsArgs = {
  input: BulkSetMasterMaterialVendorsInputDto;
};


export type MutationCreateBranchArgs = {
  input: CreateBranchInputDto;
};


export type MutationCreateEventArgs = {
  input: CreateEventInputDto;
};


export type MutationCreateEventTemplateArgs = {
  input: CreateEventTemplateInputDto;
};


export type MutationCreateMasterCategoryArgs = {
  input: CreateMasterCategoryInputDto;
};


export type MutationCreateMasterCategoryGroupArgs = {
  input: CreateMasterCategoryGroupInputDto;
};


export type MutationCreateMasterItemArgs = {
  input: CreateMasterItemInputDto;
};


export type MutationCreateMasterMaterialArgs = {
  input: CreateMasterMaterialInputDto;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInputDto;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInputDto;
};


export type MutationDeleteEventTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMasterCategoryGroupArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateEventItemsLabelsPdfArgs = {
  input: EventItemsLabelsPdfGenerationInputDto;
};


export type MutationGenerateEventTemplatePdfArgs = {
  input: EventTemplatePdfGenerationInputDto;
};


export type MutationGenerateEventsItemsMaterialsPdfArgs = {
  input: MaterialsEventsPdfGenerationInputDto;
};


export type MutationGenerateEventsItemsPdfArgs = {
  input: EventsItemsPdfGenerationInputDto;
};


export type MutationGenerateManagerEventsPdfArgs = {
  input: ManagerEventsPdfGenerationInputDto;
};


export type MutationGenerateMaterialVendorReportsArgs = {
  input: GenerateMaterialVendorReportsInputDto;
};


export type MutationGenerateMenuItemVendorReportsArgs = {
  input: GenerateMenuItemVendorReportsInputDto;
};


export type MutationLoginArgs = {
  input: LoginInputDto;
};


export type MutationSetEventItemsArgs = {
  input: SetEventItemsInputDto;
};


export type MutationSetEventTemplateItemsArgs = {
  input: SetEventTemplateItemsInputDto;
};


export type MutationSetMasterItemMaterialsArgs = {
  input: SetMasterItemMaterialsInputDto;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInputDto;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInputDto;
};


export type MutationUpdateEventItemMaterialQuantitiesArgs = {
  input: UpdateEventItemMaterialQuantitiesInputDto;
};


export type MutationUpdateEventStatusArgs = {
  input: UpdateEventStatusInputDto;
};


export type MutationUpdateEventTemplateArgs = {
  input: UpdateEventTemplateInputDto;
};


export type MutationUpdateMasterCategoryArgs = {
  input: UpdateMasterCategoryInputDto;
};


export type MutationUpdateMasterCategoryGroupArgs = {
  input: UpdateMasterCategoryGroupInputDto;
};


export type MutationUpdateMasterCategorySequenceArgs = {
  input: SetSequenceMasterItemInputDto;
};


export type MutationUpdateMasterItemArgs = {
  input: UpdateMasterItemInputDto;
};


export type MutationUpdateMasterItemSequenceArgs = {
  input: SetSequenceMasterItemInputDto;
};


export type MutationUpdateMasterMaterialArgs = {
  input: UpdateMasterMaterialInputDto;
};


export type MutationUpdateMasterMaterialSequenceArgs = {
  input: SetSequenceMasterItemInputDto;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInputDto;
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInputDto;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInputDto;
};

export type OperationInfo = {
  __typename?: 'OperationInfo';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type OrderActivityLogInputDto = {
  orderId: Scalars['UUID']['input'];
};

export type OrderBasicDto = {
  __typename?: 'OrderBasicDTO';
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: OrderEventStatusEnum;
  totalEvents?: Maybe<Scalars['Int']['output']>;
};

export type OrderDto = {
  __typename?: 'OrderDTO';
  customer: CustomerBasicDto;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: OrderEventStatusEnum;
  totalEvents?: Maybe<Scalars['Int']['output']>;
};

/** Order / Event status enum */
export enum OrderEventStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Estimated = 'ESTIMATED',
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED'
}

/** Order period enum */
export enum OrderPeriodEnum {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type OrderWithEventsDto = {
  __typename?: 'OrderWithEventsDTO';
  customer: CustomerBasicDto;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  events: Array<EventWithItemsCountDto>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: OrderEventStatusEnum;
  totalEvents?: Maybe<Scalars['Int']['output']>;
};

export type OrdersDto = {
  __typename?: 'OrdersDTO';
  edges: Array<OrderDto>;
  pageInfo: PageInfo;
};

export type OrdersFiltersInputDto = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<OrderPeriodEnum>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderEventStatusEnum>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  totalEdges: Scalars['Float']['output'];
};

export type PaginationInputDto = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  branches: Array<BranchDto>;
  client: ClientDto;
  customer: CustomerWithOrders;
  customers: CustomersDto;
  eventItems: EventWithItemsDto;
  eventItemsWithMaterials: EventWithItemsAndMaterialsDto;
  eventTemplate: EventTemplateDto;
  eventTemplateSummaries: Array<EventTemplateSummaryDto>;
  eventTemplates: Array<EventTemplateDto>;
  events: EventsDto;
  masterCategories: Array<MasterCategoryBasicDto>;
  masterCategoryGroups: Array<MasterCategoryGroupDto>;
  masterItem: MasterItemDetailDto;
  masterItems: Array<MasterItemDto>;
  masterMaterialCategories: Array<MasterMaterialDto>;
  masterMaterialCategory: MasterMaterialCategoryDto;
  materialsVendorsByEventIds: Array<EventReportVendorDto>;
  menuItemsVendorsByEventIds: Array<EventReportVendorDto>;
  order: OrderWithEventsDto;
  orderActivityLog: Array<ActivityLogEntryDto>;
  orders: OrdersDto;
  ping: Scalars['String']['output'];
  suggestedTemplates: Array<EventTemplateSummaryDto>;
  vendors: Array<VendorDto>;
};


export type QueryCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomersArgs = {
  filters?: InputMaybe<CustomersFiltersInputDto>;
  pagination: PaginationInputDto;
};


export type QueryEventItemsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEventItemsWithMaterialsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEventTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEventsArgs = {
  filters: EventsFiltersInputDto;
  pagination: PaginationInputDto;
};


export type QueryMasterCategoryGroupsArgs = {
  type?: InputMaybe<CategoryTypeEnum>;
};


export type QueryMasterItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMasterItemsArgs = {
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMasterMaterialCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMaterialsVendorsByEventIdsArgs = {
  eventIds: Array<Scalars['UUID']['input']>;
};


export type QueryMenuItemsVendorsByEventIdsArgs = {
  eventIds: Array<Scalars['UUID']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrderActivityLogArgs = {
  input: OrderActivityLogInputDto;
};


export type QueryOrdersArgs = {
  filters: OrdersFiltersInputDto;
  pagination: PaginationInputDto;
};


export type QuerySuggestedTemplatesArgs = {
  eventName: Scalars['String']['input'];
  pax?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVendorsArgs = {
  scopeOfWork?: InputMaybe<Array<ScopeOfWorkEnum>>;
};

/** Scope of work for the event item */
export enum ScopeOfWorkEnum {
  /** Labour only, materials provided by caterer */
  Labour = 'LABOUR',
  /** Service only, no materials */
  ServiceOnly = 'SERVICE_ONLY',
  /** Supply of materials only, no labour */
  SupplyOnly = 'SUPPLY_ONLY',
  /** Includes materials along with labour */
  WithMaterials = 'WITH_MATERIALS'
}

export type SequenceUpdateMasterItemDto = {
  id: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
};

export type SequenceUpdateMasterItemResponseDto = {
  __typename?: 'SequenceUpdateMasterItemResponseDTO';
  operationInfo: OperationInfo;
};

export type SetEventItemResponseDto = {
  __typename?: 'SetEventItemResponseDTO';
  operationInfo: OperationInfo;
};

export type SetEventItemsInputDto = {
  eventItems?: InputMaybe<Array<EventItemInputDto>>;
  id: Scalars['UUID']['input'];
};

export type SetEventTemplateItemsInputDto = {
  items: Array<EventTemplateItemInputDto>;
  templateId: Scalars['UUID']['input'];
};

export type SetMasterItemMaterialsInputDto = {
  masterItemId: Scalars['UUID']['input'];
  masterItemMaterials: Array<MasterItemMaterialInputDto>;
};

export type SetSequenceMasterItemInputDto = {
  masterItems: Array<SequenceUpdateMasterItemDto>;
};

export type UpdateBranchInputDto = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateEventInputDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pax?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  time: Scalars['String']['input'];
};

export type UpdateEventItemMaterialQtyInputDto = {
  masterMaterialId: Scalars['UUID']['input'];
  materialQty?: InputMaybe<Scalars['Float']['input']>;
  materialUnit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventItemMaterialQuantitiesInputDto = {
  eventItemId: Scalars['UUID']['input'];
  materials: Array<UpdateEventItemMaterialQtyInputDto>;
};

export type UpdateEventResponseDto = {
  __typename?: 'UpdateEventResponseDTO';
  operationInfo: OperationInfo;
};

export type UpdateEventStatusInputDto = {
  id: Scalars['UUID']['input'];
  status: OrderEventStatusEnum;
};

export type UpdateEventStatusResponseDto = {
  __typename?: 'UpdateEventStatusResponseDTO';
  operationInfo: OperationInfo;
};

export type UpdateEventTemplateInputDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  suggestionCriteria?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateMasterCategoryGroupInputDto = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  type: CategoryTypeEnum;
};

export type UpdateMasterCategoryInputDto = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  showCategoryLabel?: InputMaybe<Scalars['Boolean']['input']>;
  type: CategoryTypeEnum;
};

export type UpdateMasterItemInputDto = {
  defaultExtraRate?: InputMaybe<Scalars['Float']['input']>;
  defaultExtraUnit?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isExtraByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExtraChargeable?: InputMaybe<Scalars['Boolean']['input']>;
  masterCategoryId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  vendorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateMasterMaterialInputDto = {
  id: Scalars['UUID']['input'];
  masterCategoryId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  vendorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateOrderInputDto = {
  customer?: InputMaybe<CustomerInputDto>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderResponseDto = {
  __typename?: 'UpdateOrderResponseDTO';
  operationInfo: OperationInfo;
};

export type UpdateOrderStatusInputDto = {
  id: Scalars['UUID']['input'];
  status: OrderEventStatusEnum;
};

export type UpdateOrderStatusResponseDto = {
  __typename?: 'UpdateOrderStatusResponseDTO';
  operationInfo: OperationInfo;
};

export type UpdateVendorInputDto = {
  contactNo: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
};

export type UserDto = {
  __typename?: 'UserDTO';
  clientId: Scalars['UUID']['output'];
  contactNo: Scalars['PhoneNumber']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
  status: UserStatusEnum;
};

/** User status enum */
export enum UserStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export type VendorAssignmentReportResponseDto = {
  __typename?: 'VendorAssignmentReportResponseDTO';
  totalVendors: Scalars['Float']['output'];
  vendors: Array<VendorPdfItemDto>;
};

export type VendorDto = {
  __typename?: 'VendorDTO';
  contactNo: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  scopeOfWork: Array<ScopeOfWorkEnum>;
};

export type VendorPdfItemDto = {
  __typename?: 'VendorPDFItemDTO';
  filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type VendorResponseDto = {
  __typename?: 'VendorResponseDTO';
  id: Scalars['UUID']['output'];
  operationInfo: OperationInfo;
};

export type LoginMutationVariables = Exact<{
  input: LoginInputDto;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayloadDTO', token: string, permissions: any, user: { __typename?: 'UserDTO', id: any, name: string, contactNo: any, status: UserStatusEnum, roleName: string }, branches: Array<{ __typename?: 'BranchDTO', id: any, name: string }> } };

export type GetEventsQueryVariables = Exact<{
  filters: EventsFiltersInputDto;
  pagination: PaginationInputDto;
}>;


export type GetEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventsDTO', edges: Array<{ __typename?: 'EventWithOrderDTO', id: any, name: string, date: string, time: string, status: OrderEventStatusEnum, pax?: number | null, notes?: string | null, rate?: number | null, itemsCount: number, order: { __typename?: 'OrderBasicDTO', id: any, name: string, number: string }, customer: { __typename?: 'CustomerBasicDTO', id: any, name: string, contactNo: any } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number, limit: number, offset: number, totalEdges: number } } };

export type GetEventItemsByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetEventItemsByIdQuery = { __typename?: 'Query', eventItems: { __typename?: 'EventWithItemsDTO', id: any, name: string, date: string, time: string, address?: string | null, pax?: number | null, rate?: number | null, status: OrderEventStatusEnum, notes?: string | null, order: { __typename?: 'OrderBasicDTO', id: any, name: string, number: string, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, status: OrderEventStatusEnum }, customer: { __typename?: 'CustomerBasicDTO', id: any, name: string, contactNo: any, address?: string | null }, items: Array<{ __typename?: 'EventItemFlatDTO', id?: any | null, isExtra: boolean, isInternal: boolean, extraQty?: number | null, extraRate?: number | null, alternativeGroupId?: any | null, groupPickCount?: number | null, masterItem: { __typename?: 'MasterItemBasicDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null }, category: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean } }> } };

export type GetMenuItemsVendorsByEventIdsQueryVariables = Exact<{
  eventIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetMenuItemsVendorsByEventIdsQuery = { __typename?: 'Query', menuItemsVendorsByEventIds: Array<{ __typename?: 'EventReportVendorDTO', id: any, name: string, contactNo?: string | null, scopeOfWork: Array<ScopeOfWorkEnum>, eventIds: Array<any> }> };

export type GetMaterialsVendorsByEventIdsQueryVariables = Exact<{
  eventIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetMaterialsVendorsByEventIdsQuery = { __typename?: 'Query', materialsVendorsByEventIds: Array<{ __typename?: 'EventReportVendorDTO', id: any, name: string, contactNo?: string | null, scopeOfWork: Array<ScopeOfWorkEnum>, eventIds: Array<any> }> };

export type GetEventItemsWithMaterialsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetEventItemsWithMaterialsQuery = { __typename?: 'Query', eventItemsWithMaterials: { __typename?: 'EventWithItemsAndMaterialsDTO', id: any, name: string, date: string, time: string, address?: string | null, pax?: number | null, rate?: number | null, status: OrderEventStatusEnum, notes?: string | null, order: { __typename?: 'OrderBasicDTO', id: any, name: string, number: string, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, status: OrderEventStatusEnum }, customer: { __typename?: 'CustomerBasicDTO', id: any, name: string, contactNo: any, address?: string | null }, items: Array<{ __typename?: 'EventItemWithMaterialsFlatDTO', id?: any | null, scopeOfWork?: ScopeOfWorkEnum | null, serviceDate?: string | null, serviceTime?: string | null, counterCount?: number | null, itemQty?: number | null, itemUnit?: string | null, isExtra: boolean, isInternal: boolean, extraQty?: number | null, extraRate?: number | null, masterItem: { __typename?: 'MasterItemBasicDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, defaultExtraRate?: number | null, defaultExtraUnit?: string | null, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null }, vendor?: { __typename?: 'EventItemVendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum>, vendorId: any } | null, category: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean }, materials: Array<{ __typename?: 'EventItemMaterialFlatDTO', id?: any | null, itemQty?: number | null, itemUnit?: string | null, materialQty?: number | null, materialUnit?: string | null, vendor?: { __typename?: 'EventItemMaterialVendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum>, vendorId: any } | null, masterMaterial: { __typename?: 'MasterMaterialBasicDTO', id: any, name: string, sequence: number, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null }, materialCategory: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, isInternal: boolean, showCategoryLabel: boolean } }> }> } };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInputDto;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'CreateEventResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInputDto;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'UpdateEventResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateEventStatusMutationVariables = Exact<{
  input: UpdateEventStatusInputDto;
}>;


export type UpdateEventStatusMutation = { __typename?: 'Mutation', updateEventStatus: { __typename?: 'UpdateEventStatusResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type SetEventItemsMutationVariables = Exact<{
  input: SetEventItemsInputDto;
}>;


export type SetEventItemsMutation = { __typename?: 'Mutation', setEventItems: { __typename?: 'SetEventItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type GetMasterCategoryGroupsQueryVariables = Exact<{
  type?: InputMaybe<CategoryTypeEnum>;
}>;


export type GetMasterCategoryGroupsQuery = { __typename?: 'Query', masterCategoryGroups: Array<{ __typename?: 'MasterCategoryGroupDTO', id: any, name: string, type: CategoryTypeEnum, sequence: number }> };

export type GetMasterCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterCategoriesQuery = { __typename?: 'Query', masterCategories: Array<{ __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean }> };

export type GetMasterItemCategoriesWithItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterItemCategoriesWithItemsQuery = { __typename?: 'Query', masterItems: Array<{ __typename?: 'MasterItemDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, defaultExtraRate?: number | null, defaultExtraUnit?: string | null, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null, category: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean } }> };

export type GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterItemCategoriesWithItemsAndMaterialsQuery = { __typename?: 'Query', masterItems: Array<{ __typename?: 'MasterItemDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, defaultExtraRate?: number | null, defaultExtraUnit?: string | null, materialCount: number, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null, category: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean } }> };

export type GetMasterItemQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMasterItemQuery = { __typename?: 'Query', masterItem: { __typename?: 'MasterItemDetailDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, defaultExtraRate?: number | null, defaultExtraUnit?: string | null, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null, masterItemCategory: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum }, masterMaterialCategories: Array<{ __typename?: 'MasterItemMaterialCategoryDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, masterMaterials: Array<{ __typename?: 'MasterItemMaterialDTO', id: any, name: string, sequence: number, isVisibleToCustomer: boolean, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null }> }> } };

export type CreateMasterCategoryGroupMutationVariables = Exact<{
  input: CreateMasterCategoryGroupInputDto;
}>;


export type CreateMasterCategoryGroupMutation = { __typename?: 'Mutation', createMasterCategoryGroup: { __typename?: 'MasterCategoryGroupResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterCategoryGroupMutationVariables = Exact<{
  input: UpdateMasterCategoryGroupInputDto;
}>;


export type UpdateMasterCategoryGroupMutation = { __typename?: 'Mutation', updateMasterCategoryGroup: { __typename?: 'MasterCategoryGroupResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type DeleteMasterCategoryGroupMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteMasterCategoryGroupMutation = { __typename?: 'Mutation', deleteMasterCategoryGroup: { __typename?: 'MasterCategoryGroupResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type CreateMasterCategoryMutationVariables = Exact<{
  input: CreateMasterCategoryInputDto;
}>;


export type CreateMasterCategoryMutation = { __typename?: 'Mutation', createMasterCategory: { __typename?: 'MasterCategoryResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterCategoryMutationVariables = Exact<{
  input: UpdateMasterCategoryInputDto;
}>;


export type UpdateMasterCategoryMutation = { __typename?: 'Mutation', updateMasterCategory: { __typename?: 'MasterCategoryResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterCategorySequenceMutationVariables = Exact<{
  input: SetSequenceMasterItemInputDto;
}>;


export type UpdateMasterCategorySequenceMutation = { __typename?: 'Mutation', updateMasterCategorySequence: { __typename?: 'SequenceUpdateMasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type CreateMasterItemMutationVariables = Exact<{
  input: CreateMasterItemInputDto;
}>;


export type CreateMasterItemMutation = { __typename?: 'Mutation', createMasterItem: { __typename?: 'MasterItemResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterItemMutationVariables = Exact<{
  input: UpdateMasterItemInputDto;
}>;


export type UpdateMasterItemMutation = { __typename?: 'Mutation', updateMasterItem: { __typename?: 'MasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterItemSequenceMutationVariables = Exact<{
  input: SetSequenceMasterItemInputDto;
}>;


export type UpdateMasterItemSequenceMutation = { __typename?: 'Mutation', updateMasterItemSequence: { __typename?: 'SequenceUpdateMasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type BulkSetMasterItemDefaultsMutationVariables = Exact<{
  input: BulkSetMasterItemVendorsInputDto;
}>;


export type BulkSetMasterItemDefaultsMutation = { __typename?: 'Mutation', bulkSetMasterItemDefaults: { __typename?: 'MasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type GetMasterMaterialCategoriesWithMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterMaterialCategoriesWithMaterialsQuery = { __typename?: 'Query', masterMaterialCategories: Array<{ __typename?: 'MasterMaterialDTO', id: any, name: string, sequence: number, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null, category: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean } }> };

export type GetMasterMaterialCategoryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMasterMaterialCategoryQuery = { __typename?: 'Query', masterMaterialCategory: { __typename?: 'MasterMaterialCategoryDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, masterMaterials: Array<{ __typename?: 'MasterMaterialBasicDTO', id: any, name: string, sequence: number, vendors?: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> | null }> } };

export type SetMasterItemMaterialsMutationVariables = Exact<{
  input: SetMasterItemMaterialsInputDto;
}>;


export type SetMasterItemMaterialsMutation = { __typename?: 'Mutation', setMasterItemMaterials: { __typename?: 'MasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type CreateMasterMaterialMutationVariables = Exact<{
  input: CreateMasterMaterialInputDto;
}>;


export type CreateMasterMaterialMutation = { __typename?: 'Mutation', createMasterMaterial: { __typename?: 'MasterMaterialResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterMaterialMutationVariables = Exact<{
  input: UpdateMasterMaterialInputDto;
}>;


export type UpdateMasterMaterialMutation = { __typename?: 'Mutation', updateMasterMaterial: { __typename?: 'MasterMaterialResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateMasterMaterialSequenceMutationVariables = Exact<{
  input: SetSequenceMasterItemInputDto;
}>;


export type UpdateMasterMaterialSequenceMutation = { __typename?: 'Mutation', updateMasterMaterialSequence: { __typename?: 'SequenceUpdateMasterItemResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type AssignEventItemVendorMutationVariables = Exact<{
  input: AssignEventItemVendorInputDto;
}>;


export type AssignEventItemVendorMutation = { __typename?: 'Mutation', assignEventItemVendor: { __typename?: 'AssignEventItemVendorResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type BulkAssignEventItemVendorMutationVariables = Exact<{
  input: BulkAssignEventItemVendorInputDto;
}>;


export type BulkAssignEventItemVendorMutation = { __typename?: 'Mutation', bulkAssignEventItemVendor: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } };

export type UpdateEventItemMaterialQuantitiesMutationVariables = Exact<{
  input: UpdateEventItemMaterialQuantitiesInputDto;
}>;


export type UpdateEventItemMaterialQuantitiesMutation = { __typename?: 'Mutation', updateEventItemMaterialQuantities: { __typename?: 'BaseResponse', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type BulkAssignMaterialVendorMutationVariables = Exact<{
  input: BulkAssignMaterialVendorInputDto;
}>;


export type BulkAssignMaterialVendorMutation = { __typename?: 'Mutation', bulkAssignMaterialVendor: { __typename?: 'BaseResponse', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type BulkSetMasterMaterialDefaultsMutationVariables = Exact<{
  input: BulkSetMasterMaterialVendorsInputDto;
}>;


export type BulkSetMasterMaterialDefaultsMutation = { __typename?: 'Mutation', bulkSetMasterMaterialDefaults: { __typename?: 'MasterMaterialResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type GetOrderActivityLogQueryVariables = Exact<{
  input: OrderActivityLogInputDto;
}>;


export type GetOrderActivityLogQuery = { __typename?: 'Query', orderActivityLog: Array<{ __typename?: 'ActivityLogEntryDTO', id: any, entityType: string, action: string, changes: any, summary: string, createdAt: any, eventName?: string | null, performedBy: { __typename?: 'ActivityLogUserDTO', id: any, name: string } }> };

export type GetOrdersQueryVariables = Exact<{
  filters: OrdersFiltersInputDto;
  pagination: PaginationInputDto;
}>;


export type GetOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersDTO', edges: Array<{ __typename?: 'OrderDTO', id: any, name: string, number: string, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, status: OrderEventStatusEnum, totalEvents?: number | null, customer: { __typename?: 'CustomerBasicDTO', id: any, name: string, contactNo: any, address?: string | null } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number, limit: number, offset: number, totalEdges: number } } };

export type GetOrderWithEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetOrderWithEventsQuery = { __typename?: 'Query', order: { __typename?: 'OrderWithEventsDTO', id: any, name: string, number: string, startDate?: string | null, startTime?: string | null, endDate?: string | null, endTime?: string | null, status: OrderEventStatusEnum, customer: { __typename?: 'CustomerBasicDTO', id: any, name: string, contactNo: any, address?: string | null }, events: Array<{ __typename?: 'EventWithItemsCountDTO', id: any, name: string, address?: string | null, date: string, time: string, notes?: string | null, pax?: number | null, rate?: number | null, status: OrderEventStatusEnum, totalMenuItems: number }> } };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInputDto;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'CreateOrderResponseDTO', id?: any | null, customerId?: any | null, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInputDto;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'UpdateOrderResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateOrderStatusMutationVariables = Exact<{
  input: UpdateOrderStatusInputDto;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'Mutation', updateOrderStatus: { __typename?: 'UpdateOrderStatusResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type GenerateEventsItemsPdfMutationVariables = Exact<{
  input: EventsItemsPdfGenerationInputDto;
}>;


export type GenerateEventsItemsPdfMutation = { __typename?: 'Mutation', generateEventsItemsPDF: { __typename?: 'EventsItemsPDFResponseDTO', totalEvents: number, events: Array<{ __typename?: 'EventItemPDFEventDTO', eventId: string, filename: string, path: string }> } };

export type GenerateManagerEventsPdfMutationVariables = Exact<{
  input: ManagerEventsPdfGenerationInputDto;
}>;


export type GenerateManagerEventsPdfMutation = { __typename?: 'Mutation', generateManagerEventsPDF: { __typename?: 'EventsItemsPDFResponseDTO', totalEvents: number, events: Array<{ __typename?: 'EventItemPDFEventDTO', eventId: string, filename: string, path: string }> } };

export type GenerateEventsItemsMaterialsPdfMutationVariables = Exact<{
  input: MaterialsEventsPdfGenerationInputDto;
}>;


export type GenerateEventsItemsMaterialsPdfMutation = { __typename?: 'Mutation', generateEventsItemsMaterialsPDF: { __typename?: 'EventsItemsPDFResponseDTO', totalEvents: number, events: Array<{ __typename?: 'EventItemPDFEventDTO', eventId: string, filename: string, path: string }> } };

export type GenerateEventItemsLabelsPdfMutationVariables = Exact<{
  input: EventItemsLabelsPdfGenerationInputDto;
}>;


export type GenerateEventItemsLabelsPdfMutation = { __typename?: 'Mutation', generateEventItemsLabelsPDF: { __typename?: 'EventItemsLabelsPDFResponseDTO', filename: string, path: string } };

export type GenerateMenuItemVendorReportsMutationVariables = Exact<{
  input: GenerateMenuItemVendorReportsInputDto;
}>;


export type GenerateMenuItemVendorReportsMutation = { __typename?: 'Mutation', generateMenuItemVendorReports: { __typename?: 'VendorAssignmentReportResponseDTO', totalVendors: number, vendors: Array<{ __typename?: 'VendorPDFItemDTO', vendorId: string, vendorName: string, path: string, filename: string }> } };

export type GenerateMaterialVendorReportsMutationVariables = Exact<{
  input: GenerateMaterialVendorReportsInputDto;
}>;


export type GenerateMaterialVendorReportsMutation = { __typename?: 'Mutation', generateMaterialVendorReports: { __typename?: 'MaterialVendorReportResponseDTO', totalVendors: number, vendors: Array<{ __typename?: 'VendorPDFItemDTO', vendorId: string, vendorName: string, path: string, filename: string }> } };

export type GetEventTemplateSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventTemplateSummariesQuery = { __typename?: 'Query', eventTemplateSummaries: Array<{ __typename?: 'EventTemplateSummaryDTO', id: any, name: string, description?: string | null, suggestionCriteria?: any | null, rate?: number | null, isActive: boolean, itemCount: number, categoryCount: number }> };

export type GetEventTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetEventTemplateQuery = { __typename?: 'Query', eventTemplate: { __typename?: 'EventTemplateDTO', id: any, name: string, description?: string | null, suggestionCriteria?: any | null, rate?: number | null, isActive: boolean, categories: Array<{ __typename?: 'EventTemplateItemsByCategoryDTO', masterCategory: { __typename?: 'MasterCategoryBasicDTO', id: any, name: string, sequence: number, type: CategoryTypeEnum, groupId?: any | null, groupName?: string | null, isInternal: boolean, showCategoryLabel: boolean }, templateItems: Array<{ __typename?: 'EventTemplateItemDTO', id: any, alternativeGroupId?: any | null, groupPickCount?: number | null, masterItem?: { __typename?: 'MasterItemBasicDTO', id: any, name: string, sequence: number, isExtraChargeable: boolean, isExtraByDefault: boolean, defaultExtraRate?: number | null } | null }> }> } };

export type GetSuggestedTemplatesQueryVariables = Exact<{
  eventName: Scalars['String']['input'];
  pax?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSuggestedTemplatesQuery = { __typename?: 'Query', suggestedTemplates: Array<{ __typename?: 'EventTemplateSummaryDTO', id: any, name: string, description?: string | null, suggestionCriteria?: any | null, rate?: number | null, isActive: boolean, itemCount: number, categoryCount: number }> };

export type CreateEventTemplateMutationVariables = Exact<{
  input: CreateEventTemplateInputDto;
}>;


export type CreateEventTemplateMutation = { __typename?: 'Mutation', createEventTemplate: { __typename?: 'EventTemplateResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateEventTemplateMutationVariables = Exact<{
  input: UpdateEventTemplateInputDto;
}>;


export type UpdateEventTemplateMutation = { __typename?: 'Mutation', updateEventTemplate: { __typename?: 'EventTemplateResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type SetEventTemplateItemsMutationVariables = Exact<{
  input: SetEventTemplateItemsInputDto;
}>;


export type SetEventTemplateItemsMutation = { __typename?: 'Mutation', setEventTemplateItems: { __typename?: 'EventTemplateResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type DeleteEventTemplateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventTemplateMutation = { __typename?: 'Mutation', deleteEventTemplate: { __typename?: 'EventTemplateResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type GenerateEventTemplatePdfMutationVariables = Exact<{
  input: EventTemplatePdfGenerationInputDto;
}>;


export type GenerateEventTemplatePdfMutation = { __typename?: 'Mutation', generateEventTemplatePDF: { __typename?: 'EventTemplatePDFResponseDTO', filename: string, path: string } };

export type GetMasterVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterVendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'VendorDTO', id: any, name: string, contactNo: string, scopeOfWork: Array<ScopeOfWorkEnum> }> };

export type CreateVendorMutationVariables = Exact<{
  input: CreateVendorInputDto;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'VendorResponseDTO', id: any, operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };

export type UpdateVendorMutationVariables = Exact<{
  input: UpdateVendorInputDto;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'VendorResponseDTO', operationInfo: { __typename?: 'OperationInfo', success: boolean, message: string, code?: string | null } } };


export const LoginDocument = gql`
    mutation Login($input: LoginInputDTO!) {
  login(input: $input) {
    token
    user {
      id
      name
      contactNo
      status
      roleName
    }
    branches {
      id
      name
    }
    permissions
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const GetEventsDocument = gql`
    query GetEvents($filters: EventsFiltersInputDTO!, $pagination: PaginationInputDTO!) {
  events(filters: $filters, pagination: $pagination) {
    edges {
      id
      name
      date
      time
      status
      pax
      notes
      rate
      itemsCount
      order {
        id
        name
        number
      }
      customer {
        id
        name
        contactNo
      }
    }
    pageInfo {
      totalCount
      limit
      offset
      totalEdges
    }
  }
}
    `;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables> & ({ variables: GetEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
// @ts-ignore
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsQuery, GetEventsQueryVariables>;
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsQuery | undefined, GetEventsQueryVariables>;
export function useGetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetEventItemsByIdDocument = gql`
    query GetEventItemsById($id: UUID!) {
  eventItems(id: $id) {
    id
    name
    date
    time
    address
    pax
    rate
    status
    notes
    order {
      id
      name
      number
      startDate
      startTime
      endDate
      endTime
      status
    }
    customer {
      id
      name
      contactNo
      address
    }
    items {
      id
      masterItem {
        id
        name
        sequence
        isExtraChargeable
        isExtraByDefault
        vendors {
          id
          name
          contactNo
          scopeOfWork
        }
      }
      isExtra
      isInternal
      extraQty
      extraRate
      alternativeGroupId
      groupPickCount
      category {
        id
        name
        sequence
        type
        groupId
        groupName
        isInternal
        showCategoryLabel
      }
    }
  }
}
    `;

/**
 * __useGetEventItemsByIdQuery__
 *
 * To run a query within a React component, call `useGetEventItemsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventItemsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventItemsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventItemsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables> & ({ variables: GetEventItemsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>(GetEventItemsByIdDocument, options);
      }
export function useGetEventItemsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>(GetEventItemsByIdDocument, options);
        }
// @ts-ignore
export function useGetEventItemsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>;
export function useGetEventItemsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventItemsByIdQuery | undefined, GetEventItemsByIdQueryVariables>;
export function useGetEventItemsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>(GetEventItemsByIdDocument, options);
        }
export type GetEventItemsByIdQueryHookResult = ReturnType<typeof useGetEventItemsByIdQuery>;
export type GetEventItemsByIdLazyQueryHookResult = ReturnType<typeof useGetEventItemsByIdLazyQuery>;
export type GetEventItemsByIdSuspenseQueryHookResult = ReturnType<typeof useGetEventItemsByIdSuspenseQuery>;
export type GetEventItemsByIdQueryResult = Apollo.QueryResult<GetEventItemsByIdQuery, GetEventItemsByIdQueryVariables>;
export const GetMenuItemsVendorsByEventIdsDocument = gql`
    query GetMenuItemsVendorsByEventIds($eventIds: [UUID!]!) {
  menuItemsVendorsByEventIds(eventIds: $eventIds) {
    id
    name
    contactNo
    scopeOfWork
    eventIds
  }
}
    `;

/**
 * __useGetMenuItemsVendorsByEventIdsQuery__
 *
 * To run a query within a React component, call `useGetMenuItemsVendorsByEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemsVendorsByEventIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemsVendorsByEventIdsQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetMenuItemsVendorsByEventIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables> & ({ variables: GetMenuItemsVendorsByEventIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>(GetMenuItemsVendorsByEventIdsDocument, options);
      }
export function useGetMenuItemsVendorsByEventIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>(GetMenuItemsVendorsByEventIdsDocument, options);
        }
// @ts-ignore
export function useGetMenuItemsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>;
export function useGetMenuItemsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuItemsVendorsByEventIdsQuery | undefined, GetMenuItemsVendorsByEventIdsQueryVariables>;
export function useGetMenuItemsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>(GetMenuItemsVendorsByEventIdsDocument, options);
        }
export type GetMenuItemsVendorsByEventIdsQueryHookResult = ReturnType<typeof useGetMenuItemsVendorsByEventIdsQuery>;
export type GetMenuItemsVendorsByEventIdsLazyQueryHookResult = ReturnType<typeof useGetMenuItemsVendorsByEventIdsLazyQuery>;
export type GetMenuItemsVendorsByEventIdsSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemsVendorsByEventIdsSuspenseQuery>;
export type GetMenuItemsVendorsByEventIdsQueryResult = Apollo.QueryResult<GetMenuItemsVendorsByEventIdsQuery, GetMenuItemsVendorsByEventIdsQueryVariables>;
export const GetMaterialsVendorsByEventIdsDocument = gql`
    query GetMaterialsVendorsByEventIds($eventIds: [UUID!]!) {
  materialsVendorsByEventIds(eventIds: $eventIds) {
    id
    name
    contactNo
    scopeOfWork
    eventIds
  }
}
    `;

/**
 * __useGetMaterialsVendorsByEventIdsQuery__
 *
 * To run a query within a React component, call `useGetMaterialsVendorsByEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsVendorsByEventIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsVendorsByEventIdsQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetMaterialsVendorsByEventIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables> & ({ variables: GetMaterialsVendorsByEventIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>(GetMaterialsVendorsByEventIdsDocument, options);
      }
export function useGetMaterialsVendorsByEventIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>(GetMaterialsVendorsByEventIdsDocument, options);
        }
// @ts-ignore
export function useGetMaterialsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>;
export function useGetMaterialsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaterialsVendorsByEventIdsQuery | undefined, GetMaterialsVendorsByEventIdsQueryVariables>;
export function useGetMaterialsVendorsByEventIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>(GetMaterialsVendorsByEventIdsDocument, options);
        }
export type GetMaterialsVendorsByEventIdsQueryHookResult = ReturnType<typeof useGetMaterialsVendorsByEventIdsQuery>;
export type GetMaterialsVendorsByEventIdsLazyQueryHookResult = ReturnType<typeof useGetMaterialsVendorsByEventIdsLazyQuery>;
export type GetMaterialsVendorsByEventIdsSuspenseQueryHookResult = ReturnType<typeof useGetMaterialsVendorsByEventIdsSuspenseQuery>;
export type GetMaterialsVendorsByEventIdsQueryResult = Apollo.QueryResult<GetMaterialsVendorsByEventIdsQuery, GetMaterialsVendorsByEventIdsQueryVariables>;
export const GetEventItemsWithMaterialsDocument = gql`
    query GetEventItemsWithMaterials($id: UUID!) {
  eventItemsWithMaterials(id: $id) {
    id
    name
    date
    time
    address
    pax
    rate
    status
    notes
    order {
      id
      name
      number
      startDate
      startTime
      endDate
      endTime
      status
    }
    customer {
      id
      name
      contactNo
      address
    }
    items {
      id
      masterItem {
        id
        name
        sequence
        isExtraChargeable
        isExtraByDefault
        defaultExtraRate
        defaultExtraUnit
        vendors {
          id
          name
          contactNo
          scopeOfWork
        }
      }
      vendor {
        id
        name
        contactNo
        scopeOfWork
        vendorId
      }
      scopeOfWork
      serviceDate
      serviceTime
      counterCount
      itemQty
      itemUnit
      isExtra
      isInternal
      extraQty
      extraRate
      category {
        id
        name
        sequence
        type
        groupId
        groupName
        isInternal
        showCategoryLabel
      }
      materials {
        id
        itemQty
        itemUnit
        materialQty
        materialUnit
        vendor {
          id
          name
          contactNo
          scopeOfWork
          vendorId
        }
        masterMaterial {
          id
          name
          sequence
          vendors {
            id
            name
            contactNo
            scopeOfWork
          }
        }
        materialCategory {
          id
          name
          sequence
          type
          isInternal
          showCategoryLabel
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventItemsWithMaterialsQuery__
 *
 * To run a query within a React component, call `useGetEventItemsWithMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventItemsWithMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventItemsWithMaterialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventItemsWithMaterialsQuery(baseOptions: Apollo.QueryHookOptions<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables> & ({ variables: GetEventItemsWithMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>(GetEventItemsWithMaterialsDocument, options);
      }
export function useGetEventItemsWithMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>(GetEventItemsWithMaterialsDocument, options);
        }
// @ts-ignore
export function useGetEventItemsWithMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>;
export function useGetEventItemsWithMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventItemsWithMaterialsQuery | undefined, GetEventItemsWithMaterialsQueryVariables>;
export function useGetEventItemsWithMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>(GetEventItemsWithMaterialsDocument, options);
        }
export type GetEventItemsWithMaterialsQueryHookResult = ReturnType<typeof useGetEventItemsWithMaterialsQuery>;
export type GetEventItemsWithMaterialsLazyQueryHookResult = ReturnType<typeof useGetEventItemsWithMaterialsLazyQuery>;
export type GetEventItemsWithMaterialsSuspenseQueryHookResult = ReturnType<typeof useGetEventItemsWithMaterialsSuspenseQuery>;
export type GetEventItemsWithMaterialsQueryResult = Apollo.QueryResult<GetEventItemsWithMaterialsQuery, GetEventItemsWithMaterialsQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($input: CreateEventInputDTO!) {
  createEvent(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($input: UpdateEventInputDTO!) {
  updateEvent(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventStatusDocument = gql`
    mutation UpdateEventStatus($input: UpdateEventStatusInputDTO!) {
  updateEventStatus(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateEventStatusMutationFn = Apollo.MutationFunction<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>;

/**
 * __useUpdateEventStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEventStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventStatusMutation, { data, loading, error }] = useUpdateEventStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>(UpdateEventStatusDocument, options);
      }
export type UpdateEventStatusMutationHookResult = ReturnType<typeof useUpdateEventStatusMutation>;
export type UpdateEventStatusMutationResult = Apollo.MutationResult<UpdateEventStatusMutation>;
export type UpdateEventStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>;
export const SetEventItemsDocument = gql`
    mutation SetEventItems($input: SetEventItemsInputDTO!) {
  setEventItems(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type SetEventItemsMutationFn = Apollo.MutationFunction<SetEventItemsMutation, SetEventItemsMutationVariables>;

/**
 * __useSetEventItemsMutation__
 *
 * To run a mutation, you first call `useSetEventItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventItemsMutation, { data, loading, error }] = useSetEventItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEventItemsMutation(baseOptions?: Apollo.MutationHookOptions<SetEventItemsMutation, SetEventItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEventItemsMutation, SetEventItemsMutationVariables>(SetEventItemsDocument, options);
      }
export type SetEventItemsMutationHookResult = ReturnType<typeof useSetEventItemsMutation>;
export type SetEventItemsMutationResult = Apollo.MutationResult<SetEventItemsMutation>;
export type SetEventItemsMutationOptions = Apollo.BaseMutationOptions<SetEventItemsMutation, SetEventItemsMutationVariables>;
export const GetMasterCategoryGroupsDocument = gql`
    query GetMasterCategoryGroups($type: CategoryTypeEnum) {
  masterCategoryGroups(type: $type) {
    id
    name
    type
    sequence
  }
}
    `;

/**
 * __useGetMasterCategoryGroupsQuery__
 *
 * To run a query within a React component, call `useGetMasterCategoryGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterCategoryGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterCategoryGroupsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMasterCategoryGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>(GetMasterCategoryGroupsDocument, options);
      }
export function useGetMasterCategoryGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>(GetMasterCategoryGroupsDocument, options);
        }
// @ts-ignore
export function useGetMasterCategoryGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>;
export function useGetMasterCategoryGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterCategoryGroupsQuery | undefined, GetMasterCategoryGroupsQueryVariables>;
export function useGetMasterCategoryGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>(GetMasterCategoryGroupsDocument, options);
        }
export type GetMasterCategoryGroupsQueryHookResult = ReturnType<typeof useGetMasterCategoryGroupsQuery>;
export type GetMasterCategoryGroupsLazyQueryHookResult = ReturnType<typeof useGetMasterCategoryGroupsLazyQuery>;
export type GetMasterCategoryGroupsSuspenseQueryHookResult = ReturnType<typeof useGetMasterCategoryGroupsSuspenseQuery>;
export type GetMasterCategoryGroupsQueryResult = Apollo.QueryResult<GetMasterCategoryGroupsQuery, GetMasterCategoryGroupsQueryVariables>;
export const GetMasterCategoriesDocument = gql`
    query GetMasterCategories {
  masterCategories {
    id
    name
    sequence
    type
    groupId
    groupName
    isInternal
    showCategoryLabel
  }
}
    `;

/**
 * __useGetMasterCategoriesQuery__
 *
 * To run a query within a React component, call `useGetMasterCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>(GetMasterCategoriesDocument, options);
      }
export function useGetMasterCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>(GetMasterCategoriesDocument, options);
        }
// @ts-ignore
export function useGetMasterCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>;
export function useGetMasterCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterCategoriesQuery | undefined, GetMasterCategoriesQueryVariables>;
export function useGetMasterCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>(GetMasterCategoriesDocument, options);
        }
export type GetMasterCategoriesQueryHookResult = ReturnType<typeof useGetMasterCategoriesQuery>;
export type GetMasterCategoriesLazyQueryHookResult = ReturnType<typeof useGetMasterCategoriesLazyQuery>;
export type GetMasterCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetMasterCategoriesSuspenseQuery>;
export type GetMasterCategoriesQueryResult = Apollo.QueryResult<GetMasterCategoriesQuery, GetMasterCategoriesQueryVariables>;
export const GetMasterItemCategoriesWithItemsDocument = gql`
    query GetMasterItemCategoriesWithItems {
  masterItems {
    id
    name
    sequence
    isExtraChargeable
    isExtraByDefault
    defaultExtraRate
    defaultExtraUnit
    vendors {
      id
      name
      contactNo
      scopeOfWork
    }
    category {
      id
      name
      sequence
      type
      groupId
      groupName
      isInternal
      showCategoryLabel
    }
  }
}
    `;

/**
 * __useGetMasterItemCategoriesWithItemsQuery__
 *
 * To run a query within a React component, call `useGetMasterItemCategoriesWithItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterItemCategoriesWithItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterItemCategoriesWithItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterItemCategoriesWithItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>(GetMasterItemCategoriesWithItemsDocument, options);
      }
export function useGetMasterItemCategoriesWithItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>(GetMasterItemCategoriesWithItemsDocument, options);
        }
// @ts-ignore
export function useGetMasterItemCategoriesWithItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>;
export function useGetMasterItemCategoriesWithItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemCategoriesWithItemsQuery | undefined, GetMasterItemCategoriesWithItemsQueryVariables>;
export function useGetMasterItemCategoriesWithItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>(GetMasterItemCategoriesWithItemsDocument, options);
        }
export type GetMasterItemCategoriesWithItemsQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsQuery>;
export type GetMasterItemCategoriesWithItemsLazyQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsLazyQuery>;
export type GetMasterItemCategoriesWithItemsSuspenseQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsSuspenseQuery>;
export type GetMasterItemCategoriesWithItemsQueryResult = Apollo.QueryResult<GetMasterItemCategoriesWithItemsQuery, GetMasterItemCategoriesWithItemsQueryVariables>;
export const GetMasterItemCategoriesWithItemsAndMaterialsDocument = gql`
    query GetMasterItemCategoriesWithItemsAndMaterials {
  masterItems(includeInternal: true) {
    id
    name
    sequence
    isExtraChargeable
    isExtraByDefault
    defaultExtraRate
    defaultExtraUnit
    vendors {
      id
      name
      contactNo
      scopeOfWork
    }
    category {
      id
      name
      sequence
      type
      groupId
      groupName
      isInternal
      showCategoryLabel
    }
    materialCount
  }
}
    `;

/**
 * __useGetMasterItemCategoriesWithItemsAndMaterialsQuery__
 *
 * To run a query within a React component, call `useGetMasterItemCategoriesWithItemsAndMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterItemCategoriesWithItemsAndMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterItemCategoriesWithItemsAndMaterialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterItemCategoriesWithItemsAndMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>(GetMasterItemCategoriesWithItemsAndMaterialsDocument, options);
      }
export function useGetMasterItemCategoriesWithItemsAndMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>(GetMasterItemCategoriesWithItemsAndMaterialsDocument, options);
        }
// @ts-ignore
export function useGetMasterItemCategoriesWithItemsAndMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>;
export function useGetMasterItemCategoriesWithItemsAndMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemCategoriesWithItemsAndMaterialsQuery | undefined, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>;
export function useGetMasterItemCategoriesWithItemsAndMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>(GetMasterItemCategoriesWithItemsAndMaterialsDocument, options);
        }
export type GetMasterItemCategoriesWithItemsAndMaterialsQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsAndMaterialsQuery>;
export type GetMasterItemCategoriesWithItemsAndMaterialsLazyQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsAndMaterialsLazyQuery>;
export type GetMasterItemCategoriesWithItemsAndMaterialsSuspenseQueryHookResult = ReturnType<typeof useGetMasterItemCategoriesWithItemsAndMaterialsSuspenseQuery>;
export type GetMasterItemCategoriesWithItemsAndMaterialsQueryResult = Apollo.QueryResult<GetMasterItemCategoriesWithItemsAndMaterialsQuery, GetMasterItemCategoriesWithItemsAndMaterialsQueryVariables>;
export const GetMasterItemDocument = gql`
    query GetMasterItem($id: UUID!) {
  masterItem(id: $id) {
    id
    name
    sequence
    isExtraChargeable
    isExtraByDefault
    defaultExtraRate
    defaultExtraUnit
    vendors {
      id
      name
      contactNo
      scopeOfWork
    }
    masterItemCategory {
      id
      name
      sequence
      type
    }
    masterMaterialCategories {
      id
      name
      sequence
      type
      masterMaterials {
        id
        name
        sequence
        isVisibleToCustomer
        vendors {
          id
          name
          contactNo
          scopeOfWork
        }
      }
    }
  }
}
    `;

/**
 * __useGetMasterItemQuery__
 *
 * To run a query within a React component, call `useGetMasterItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMasterItemQuery(baseOptions: Apollo.QueryHookOptions<GetMasterItemQuery, GetMasterItemQueryVariables> & ({ variables: GetMasterItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterItemQuery, GetMasterItemQueryVariables>(GetMasterItemDocument, options);
      }
export function useGetMasterItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterItemQuery, GetMasterItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterItemQuery, GetMasterItemQueryVariables>(GetMasterItemDocument, options);
        }
// @ts-ignore
export function useGetMasterItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterItemQuery, GetMasterItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemQuery, GetMasterItemQueryVariables>;
export function useGetMasterItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemQuery, GetMasterItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterItemQuery | undefined, GetMasterItemQueryVariables>;
export function useGetMasterItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterItemQuery, GetMasterItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterItemQuery, GetMasterItemQueryVariables>(GetMasterItemDocument, options);
        }
export type GetMasterItemQueryHookResult = ReturnType<typeof useGetMasterItemQuery>;
export type GetMasterItemLazyQueryHookResult = ReturnType<typeof useGetMasterItemLazyQuery>;
export type GetMasterItemSuspenseQueryHookResult = ReturnType<typeof useGetMasterItemSuspenseQuery>;
export type GetMasterItemQueryResult = Apollo.QueryResult<GetMasterItemQuery, GetMasterItemQueryVariables>;
export const CreateMasterCategoryGroupDocument = gql`
    mutation CreateMasterCategoryGroup($input: CreateMasterCategoryGroupInputDTO!) {
  createMasterCategoryGroup(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateMasterCategoryGroupMutationFn = Apollo.MutationFunction<CreateMasterCategoryGroupMutation, CreateMasterCategoryGroupMutationVariables>;

/**
 * __useCreateMasterCategoryGroupMutation__
 *
 * To run a mutation, you first call `useCreateMasterCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterCategoryGroupMutation, { data, loading, error }] = useCreateMasterCategoryGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterCategoryGroupMutation, CreateMasterCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterCategoryGroupMutation, CreateMasterCategoryGroupMutationVariables>(CreateMasterCategoryGroupDocument, options);
      }
export type CreateMasterCategoryGroupMutationHookResult = ReturnType<typeof useCreateMasterCategoryGroupMutation>;
export type CreateMasterCategoryGroupMutationResult = Apollo.MutationResult<CreateMasterCategoryGroupMutation>;
export type CreateMasterCategoryGroupMutationOptions = Apollo.BaseMutationOptions<CreateMasterCategoryGroupMutation, CreateMasterCategoryGroupMutationVariables>;
export const UpdateMasterCategoryGroupDocument = gql`
    mutation UpdateMasterCategoryGroup($input: UpdateMasterCategoryGroupInputDTO!) {
  updateMasterCategoryGroup(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type UpdateMasterCategoryGroupMutationFn = Apollo.MutationFunction<UpdateMasterCategoryGroupMutation, UpdateMasterCategoryGroupMutationVariables>;

/**
 * __useUpdateMasterCategoryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMasterCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterCategoryGroupMutation, { data, loading, error }] = useUpdateMasterCategoryGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterCategoryGroupMutation, UpdateMasterCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterCategoryGroupMutation, UpdateMasterCategoryGroupMutationVariables>(UpdateMasterCategoryGroupDocument, options);
      }
export type UpdateMasterCategoryGroupMutationHookResult = ReturnType<typeof useUpdateMasterCategoryGroupMutation>;
export type UpdateMasterCategoryGroupMutationResult = Apollo.MutationResult<UpdateMasterCategoryGroupMutation>;
export type UpdateMasterCategoryGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMasterCategoryGroupMutation, UpdateMasterCategoryGroupMutationVariables>;
export const DeleteMasterCategoryGroupDocument = gql`
    mutation DeleteMasterCategoryGroup($id: UUID!) {
  deleteMasterCategoryGroup(id: $id) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type DeleteMasterCategoryGroupMutationFn = Apollo.MutationFunction<DeleteMasterCategoryGroupMutation, DeleteMasterCategoryGroupMutationVariables>;

/**
 * __useDeleteMasterCategoryGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMasterCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterCategoryGroupMutation, { data, loading, error }] = useDeleteMasterCategoryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMasterCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMasterCategoryGroupMutation, DeleteMasterCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMasterCategoryGroupMutation, DeleteMasterCategoryGroupMutationVariables>(DeleteMasterCategoryGroupDocument, options);
      }
export type DeleteMasterCategoryGroupMutationHookResult = ReturnType<typeof useDeleteMasterCategoryGroupMutation>;
export type DeleteMasterCategoryGroupMutationResult = Apollo.MutationResult<DeleteMasterCategoryGroupMutation>;
export type DeleteMasterCategoryGroupMutationOptions = Apollo.BaseMutationOptions<DeleteMasterCategoryGroupMutation, DeleteMasterCategoryGroupMutationVariables>;
export const CreateMasterCategoryDocument = gql`
    mutation CreateMasterCategory($input: CreateMasterCategoryInputDTO!) {
  createMasterCategory(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateMasterCategoryMutationFn = Apollo.MutationFunction<CreateMasterCategoryMutation, CreateMasterCategoryMutationVariables>;

/**
 * __useCreateMasterCategoryMutation__
 *
 * To run a mutation, you first call `useCreateMasterCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterCategoryMutation, { data, loading, error }] = useCreateMasterCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterCategoryMutation, CreateMasterCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterCategoryMutation, CreateMasterCategoryMutationVariables>(CreateMasterCategoryDocument, options);
      }
export type CreateMasterCategoryMutationHookResult = ReturnType<typeof useCreateMasterCategoryMutation>;
export type CreateMasterCategoryMutationResult = Apollo.MutationResult<CreateMasterCategoryMutation>;
export type CreateMasterCategoryMutationOptions = Apollo.BaseMutationOptions<CreateMasterCategoryMutation, CreateMasterCategoryMutationVariables>;
export const UpdateMasterCategoryDocument = gql`
    mutation UpdateMasterCategory($input: UpdateMasterCategoryInputDTO!) {
  updateMasterCategory(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterCategoryMutationFn = Apollo.MutationFunction<UpdateMasterCategoryMutation, UpdateMasterCategoryMutationVariables>;

/**
 * __useUpdateMasterCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMasterCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterCategoryMutation, { data, loading, error }] = useUpdateMasterCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterCategoryMutation, UpdateMasterCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterCategoryMutation, UpdateMasterCategoryMutationVariables>(UpdateMasterCategoryDocument, options);
      }
export type UpdateMasterCategoryMutationHookResult = ReturnType<typeof useUpdateMasterCategoryMutation>;
export type UpdateMasterCategoryMutationResult = Apollo.MutationResult<UpdateMasterCategoryMutation>;
export type UpdateMasterCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMasterCategoryMutation, UpdateMasterCategoryMutationVariables>;
export const UpdateMasterCategorySequenceDocument = gql`
    mutation UpdateMasterCategorySequence($input: SetSequenceMasterItemInputDTO!) {
  updateMasterCategorySequence(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterCategorySequenceMutationFn = Apollo.MutationFunction<UpdateMasterCategorySequenceMutation, UpdateMasterCategorySequenceMutationVariables>;

/**
 * __useUpdateMasterCategorySequenceMutation__
 *
 * To run a mutation, you first call `useUpdateMasterCategorySequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterCategorySequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterCategorySequenceMutation, { data, loading, error }] = useUpdateMasterCategorySequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterCategorySequenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterCategorySequenceMutation, UpdateMasterCategorySequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterCategorySequenceMutation, UpdateMasterCategorySequenceMutationVariables>(UpdateMasterCategorySequenceDocument, options);
      }
export type UpdateMasterCategorySequenceMutationHookResult = ReturnType<typeof useUpdateMasterCategorySequenceMutation>;
export type UpdateMasterCategorySequenceMutationResult = Apollo.MutationResult<UpdateMasterCategorySequenceMutation>;
export type UpdateMasterCategorySequenceMutationOptions = Apollo.BaseMutationOptions<UpdateMasterCategorySequenceMutation, UpdateMasterCategorySequenceMutationVariables>;
export const CreateMasterItemDocument = gql`
    mutation CreateMasterItem($input: CreateMasterItemInputDTO!) {
  createMasterItem(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateMasterItemMutationFn = Apollo.MutationFunction<CreateMasterItemMutation, CreateMasterItemMutationVariables>;

/**
 * __useCreateMasterItemMutation__
 *
 * To run a mutation, you first call `useCreateMasterItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterItemMutation, { data, loading, error }] = useCreateMasterItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterItemMutation, CreateMasterItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterItemMutation, CreateMasterItemMutationVariables>(CreateMasterItemDocument, options);
      }
export type CreateMasterItemMutationHookResult = ReturnType<typeof useCreateMasterItemMutation>;
export type CreateMasterItemMutationResult = Apollo.MutationResult<CreateMasterItemMutation>;
export type CreateMasterItemMutationOptions = Apollo.BaseMutationOptions<CreateMasterItemMutation, CreateMasterItemMutationVariables>;
export const UpdateMasterItemDocument = gql`
    mutation UpdateMasterItem($input: UpdateMasterItemInputDTO!) {
  updateMasterItem(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterItemMutationFn = Apollo.MutationFunction<UpdateMasterItemMutation, UpdateMasterItemMutationVariables>;

/**
 * __useUpdateMasterItemMutation__
 *
 * To run a mutation, you first call `useUpdateMasterItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterItemMutation, { data, loading, error }] = useUpdateMasterItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterItemMutation, UpdateMasterItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterItemMutation, UpdateMasterItemMutationVariables>(UpdateMasterItemDocument, options);
      }
export type UpdateMasterItemMutationHookResult = ReturnType<typeof useUpdateMasterItemMutation>;
export type UpdateMasterItemMutationResult = Apollo.MutationResult<UpdateMasterItemMutation>;
export type UpdateMasterItemMutationOptions = Apollo.BaseMutationOptions<UpdateMasterItemMutation, UpdateMasterItemMutationVariables>;
export const UpdateMasterItemSequenceDocument = gql`
    mutation UpdateMasterItemSequence($input: SetSequenceMasterItemInputDTO!) {
  updateMasterItemSequence(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterItemSequenceMutationFn = Apollo.MutationFunction<UpdateMasterItemSequenceMutation, UpdateMasterItemSequenceMutationVariables>;

/**
 * __useUpdateMasterItemSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateMasterItemSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterItemSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterItemSequenceMutation, { data, loading, error }] = useUpdateMasterItemSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterItemSequenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterItemSequenceMutation, UpdateMasterItemSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterItemSequenceMutation, UpdateMasterItemSequenceMutationVariables>(UpdateMasterItemSequenceDocument, options);
      }
export type UpdateMasterItemSequenceMutationHookResult = ReturnType<typeof useUpdateMasterItemSequenceMutation>;
export type UpdateMasterItemSequenceMutationResult = Apollo.MutationResult<UpdateMasterItemSequenceMutation>;
export type UpdateMasterItemSequenceMutationOptions = Apollo.BaseMutationOptions<UpdateMasterItemSequenceMutation, UpdateMasterItemSequenceMutationVariables>;
export const BulkSetMasterItemDefaultsDocument = gql`
    mutation BulkSetMasterItemDefaults($input: BulkSetMasterItemVendorsInputDTO!) {
  bulkSetMasterItemDefaults(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type BulkSetMasterItemDefaultsMutationFn = Apollo.MutationFunction<BulkSetMasterItemDefaultsMutation, BulkSetMasterItemDefaultsMutationVariables>;

/**
 * __useBulkSetMasterItemDefaultsMutation__
 *
 * To run a mutation, you first call `useBulkSetMasterItemDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetMasterItemDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetMasterItemDefaultsMutation, { data, loading, error }] = useBulkSetMasterItemDefaultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkSetMasterItemDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetMasterItemDefaultsMutation, BulkSetMasterItemDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSetMasterItemDefaultsMutation, BulkSetMasterItemDefaultsMutationVariables>(BulkSetMasterItemDefaultsDocument, options);
      }
export type BulkSetMasterItemDefaultsMutationHookResult = ReturnType<typeof useBulkSetMasterItemDefaultsMutation>;
export type BulkSetMasterItemDefaultsMutationResult = Apollo.MutationResult<BulkSetMasterItemDefaultsMutation>;
export type BulkSetMasterItemDefaultsMutationOptions = Apollo.BaseMutationOptions<BulkSetMasterItemDefaultsMutation, BulkSetMasterItemDefaultsMutationVariables>;
export const GetMasterMaterialCategoriesWithMaterialsDocument = gql`
    query GetMasterMaterialCategoriesWithMaterials {
  masterMaterialCategories {
    id
    name
    sequence
    vendors {
      id
      name
      contactNo
      scopeOfWork
    }
    category {
      id
      name
      sequence
      type
      groupId
      groupName
      isInternal
      showCategoryLabel
    }
  }
}
    `;

/**
 * __useGetMasterMaterialCategoriesWithMaterialsQuery__
 *
 * To run a query within a React component, call `useGetMasterMaterialCategoriesWithMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterMaterialCategoriesWithMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterMaterialCategoriesWithMaterialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterMaterialCategoriesWithMaterialsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>(GetMasterMaterialCategoriesWithMaterialsDocument, options);
      }
export function useGetMasterMaterialCategoriesWithMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>(GetMasterMaterialCategoriesWithMaterialsDocument, options);
        }
// @ts-ignore
export function useGetMasterMaterialCategoriesWithMaterialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>;
export function useGetMasterMaterialCategoriesWithMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterMaterialCategoriesWithMaterialsQuery | undefined, GetMasterMaterialCategoriesWithMaterialsQueryVariables>;
export function useGetMasterMaterialCategoriesWithMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>(GetMasterMaterialCategoriesWithMaterialsDocument, options);
        }
export type GetMasterMaterialCategoriesWithMaterialsQueryHookResult = ReturnType<typeof useGetMasterMaterialCategoriesWithMaterialsQuery>;
export type GetMasterMaterialCategoriesWithMaterialsLazyQueryHookResult = ReturnType<typeof useGetMasterMaterialCategoriesWithMaterialsLazyQuery>;
export type GetMasterMaterialCategoriesWithMaterialsSuspenseQueryHookResult = ReturnType<typeof useGetMasterMaterialCategoriesWithMaterialsSuspenseQuery>;
export type GetMasterMaterialCategoriesWithMaterialsQueryResult = Apollo.QueryResult<GetMasterMaterialCategoriesWithMaterialsQuery, GetMasterMaterialCategoriesWithMaterialsQueryVariables>;
export const GetMasterMaterialCategoryDocument = gql`
    query GetMasterMaterialCategory($id: UUID!) {
  masterMaterialCategory(id: $id) {
    id
    name
    sequence
    type
    masterMaterials {
      id
      name
      sequence
      vendors {
        id
        name
        contactNo
        scopeOfWork
      }
    }
  }
}
    `;

/**
 * __useGetMasterMaterialCategoryQuery__
 *
 * To run a query within a React component, call `useGetMasterMaterialCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterMaterialCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterMaterialCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMasterMaterialCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables> & ({ variables: GetMasterMaterialCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>(GetMasterMaterialCategoryDocument, options);
      }
export function useGetMasterMaterialCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>(GetMasterMaterialCategoryDocument, options);
        }
// @ts-ignore
export function useGetMasterMaterialCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>;
export function useGetMasterMaterialCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterMaterialCategoryQuery | undefined, GetMasterMaterialCategoryQueryVariables>;
export function useGetMasterMaterialCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>(GetMasterMaterialCategoryDocument, options);
        }
export type GetMasterMaterialCategoryQueryHookResult = ReturnType<typeof useGetMasterMaterialCategoryQuery>;
export type GetMasterMaterialCategoryLazyQueryHookResult = ReturnType<typeof useGetMasterMaterialCategoryLazyQuery>;
export type GetMasterMaterialCategorySuspenseQueryHookResult = ReturnType<typeof useGetMasterMaterialCategorySuspenseQuery>;
export type GetMasterMaterialCategoryQueryResult = Apollo.QueryResult<GetMasterMaterialCategoryQuery, GetMasterMaterialCategoryQueryVariables>;
export const SetMasterItemMaterialsDocument = gql`
    mutation setMasterItemMaterials($input: SetMasterItemMaterialsInputDTO!) {
  setMasterItemMaterials(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type SetMasterItemMaterialsMutationFn = Apollo.MutationFunction<SetMasterItemMaterialsMutation, SetMasterItemMaterialsMutationVariables>;

/**
 * __useSetMasterItemMaterialsMutation__
 *
 * To run a mutation, you first call `useSetMasterItemMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMasterItemMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMasterItemMaterialsMutation, { data, loading, error }] = useSetMasterItemMaterialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMasterItemMaterialsMutation(baseOptions?: Apollo.MutationHookOptions<SetMasterItemMaterialsMutation, SetMasterItemMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMasterItemMaterialsMutation, SetMasterItemMaterialsMutationVariables>(SetMasterItemMaterialsDocument, options);
      }
export type SetMasterItemMaterialsMutationHookResult = ReturnType<typeof useSetMasterItemMaterialsMutation>;
export type SetMasterItemMaterialsMutationResult = Apollo.MutationResult<SetMasterItemMaterialsMutation>;
export type SetMasterItemMaterialsMutationOptions = Apollo.BaseMutationOptions<SetMasterItemMaterialsMutation, SetMasterItemMaterialsMutationVariables>;
export const CreateMasterMaterialDocument = gql`
    mutation CreateMasterMaterial($input: CreateMasterMaterialInputDTO!) {
  createMasterMaterial(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateMasterMaterialMutationFn = Apollo.MutationFunction<CreateMasterMaterialMutation, CreateMasterMaterialMutationVariables>;

/**
 * __useCreateMasterMaterialMutation__
 *
 * To run a mutation, you first call `useCreateMasterMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterMaterialMutation, { data, loading, error }] = useCreateMasterMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterMaterialMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterMaterialMutation, CreateMasterMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterMaterialMutation, CreateMasterMaterialMutationVariables>(CreateMasterMaterialDocument, options);
      }
export type CreateMasterMaterialMutationHookResult = ReturnType<typeof useCreateMasterMaterialMutation>;
export type CreateMasterMaterialMutationResult = Apollo.MutationResult<CreateMasterMaterialMutation>;
export type CreateMasterMaterialMutationOptions = Apollo.BaseMutationOptions<CreateMasterMaterialMutation, CreateMasterMaterialMutationVariables>;
export const UpdateMasterMaterialDocument = gql`
    mutation UpdateMasterMaterial($input: UpdateMasterMaterialInputDTO!) {
  updateMasterMaterial(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterMaterialMutationFn = Apollo.MutationFunction<UpdateMasterMaterialMutation, UpdateMasterMaterialMutationVariables>;

/**
 * __useUpdateMasterMaterialMutation__
 *
 * To run a mutation, you first call `useUpdateMasterMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterMaterialMutation, { data, loading, error }] = useUpdateMasterMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterMaterialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterMaterialMutation, UpdateMasterMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterMaterialMutation, UpdateMasterMaterialMutationVariables>(UpdateMasterMaterialDocument, options);
      }
export type UpdateMasterMaterialMutationHookResult = ReturnType<typeof useUpdateMasterMaterialMutation>;
export type UpdateMasterMaterialMutationResult = Apollo.MutationResult<UpdateMasterMaterialMutation>;
export type UpdateMasterMaterialMutationOptions = Apollo.BaseMutationOptions<UpdateMasterMaterialMutation, UpdateMasterMaterialMutationVariables>;
export const UpdateMasterMaterialSequenceDocument = gql`
    mutation UpdateMasterMaterialSequence($input: SetSequenceMasterItemInputDTO!) {
  updateMasterMaterialSequence(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateMasterMaterialSequenceMutationFn = Apollo.MutationFunction<UpdateMasterMaterialSequenceMutation, UpdateMasterMaterialSequenceMutationVariables>;

/**
 * __useUpdateMasterMaterialSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateMasterMaterialSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterMaterialSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterMaterialSequenceMutation, { data, loading, error }] = useUpdateMasterMaterialSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterMaterialSequenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMasterMaterialSequenceMutation, UpdateMasterMaterialSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMasterMaterialSequenceMutation, UpdateMasterMaterialSequenceMutationVariables>(UpdateMasterMaterialSequenceDocument, options);
      }
export type UpdateMasterMaterialSequenceMutationHookResult = ReturnType<typeof useUpdateMasterMaterialSequenceMutation>;
export type UpdateMasterMaterialSequenceMutationResult = Apollo.MutationResult<UpdateMasterMaterialSequenceMutation>;
export type UpdateMasterMaterialSequenceMutationOptions = Apollo.BaseMutationOptions<UpdateMasterMaterialSequenceMutation, UpdateMasterMaterialSequenceMutationVariables>;
export const AssignEventItemVendorDocument = gql`
    mutation AssignEventItemVendor($input: AssignEventItemVendorInputDTO!) {
  assignEventItemVendor(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type AssignEventItemVendorMutationFn = Apollo.MutationFunction<AssignEventItemVendorMutation, AssignEventItemVendorMutationVariables>;

/**
 * __useAssignEventItemVendorMutation__
 *
 * To run a mutation, you first call `useAssignEventItemVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignEventItemVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignEventItemVendorMutation, { data, loading, error }] = useAssignEventItemVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignEventItemVendorMutation(baseOptions?: Apollo.MutationHookOptions<AssignEventItemVendorMutation, AssignEventItemVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignEventItemVendorMutation, AssignEventItemVendorMutationVariables>(AssignEventItemVendorDocument, options);
      }
export type AssignEventItemVendorMutationHookResult = ReturnType<typeof useAssignEventItemVendorMutation>;
export type AssignEventItemVendorMutationResult = Apollo.MutationResult<AssignEventItemVendorMutation>;
export type AssignEventItemVendorMutationOptions = Apollo.BaseMutationOptions<AssignEventItemVendorMutation, AssignEventItemVendorMutationVariables>;
export const BulkAssignEventItemVendorDocument = gql`
    mutation BulkAssignEventItemVendor($input: BulkAssignEventItemVendorInputDTO!) {
  bulkAssignEventItemVendor(input: $input) {
    success
    message
    code
  }
}
    `;
export type BulkAssignEventItemVendorMutationFn = Apollo.MutationFunction<BulkAssignEventItemVendorMutation, BulkAssignEventItemVendorMutationVariables>;

/**
 * __useBulkAssignEventItemVendorMutation__
 *
 * To run a mutation, you first call `useBulkAssignEventItemVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignEventItemVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignEventItemVendorMutation, { data, loading, error }] = useBulkAssignEventItemVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAssignEventItemVendorMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignEventItemVendorMutation, BulkAssignEventItemVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignEventItemVendorMutation, BulkAssignEventItemVendorMutationVariables>(BulkAssignEventItemVendorDocument, options);
      }
export type BulkAssignEventItemVendorMutationHookResult = ReturnType<typeof useBulkAssignEventItemVendorMutation>;
export type BulkAssignEventItemVendorMutationResult = Apollo.MutationResult<BulkAssignEventItemVendorMutation>;
export type BulkAssignEventItemVendorMutationOptions = Apollo.BaseMutationOptions<BulkAssignEventItemVendorMutation, BulkAssignEventItemVendorMutationVariables>;
export const UpdateEventItemMaterialQuantitiesDocument = gql`
    mutation UpdateEventItemMaterialQuantities($input: UpdateEventItemMaterialQuantitiesInputDTO!) {
  updateEventItemMaterialQuantities(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateEventItemMaterialQuantitiesMutationFn = Apollo.MutationFunction<UpdateEventItemMaterialQuantitiesMutation, UpdateEventItemMaterialQuantitiesMutationVariables>;

/**
 * __useUpdateEventItemMaterialQuantitiesMutation__
 *
 * To run a mutation, you first call `useUpdateEventItemMaterialQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventItemMaterialQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventItemMaterialQuantitiesMutation, { data, loading, error }] = useUpdateEventItemMaterialQuantitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventItemMaterialQuantitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventItemMaterialQuantitiesMutation, UpdateEventItemMaterialQuantitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventItemMaterialQuantitiesMutation, UpdateEventItemMaterialQuantitiesMutationVariables>(UpdateEventItemMaterialQuantitiesDocument, options);
      }
export type UpdateEventItemMaterialQuantitiesMutationHookResult = ReturnType<typeof useUpdateEventItemMaterialQuantitiesMutation>;
export type UpdateEventItemMaterialQuantitiesMutationResult = Apollo.MutationResult<UpdateEventItemMaterialQuantitiesMutation>;
export type UpdateEventItemMaterialQuantitiesMutationOptions = Apollo.BaseMutationOptions<UpdateEventItemMaterialQuantitiesMutation, UpdateEventItemMaterialQuantitiesMutationVariables>;
export const BulkAssignMaterialVendorDocument = gql`
    mutation BulkAssignMaterialVendor($input: BulkAssignMaterialVendorInputDTO!) {
  bulkAssignMaterialVendor(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type BulkAssignMaterialVendorMutationFn = Apollo.MutationFunction<BulkAssignMaterialVendorMutation, BulkAssignMaterialVendorMutationVariables>;

/**
 * __useBulkAssignMaterialVendorMutation__
 *
 * To run a mutation, you first call `useBulkAssignMaterialVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignMaterialVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignMaterialVendorMutation, { data, loading, error }] = useBulkAssignMaterialVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAssignMaterialVendorMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignMaterialVendorMutation, BulkAssignMaterialVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignMaterialVendorMutation, BulkAssignMaterialVendorMutationVariables>(BulkAssignMaterialVendorDocument, options);
      }
export type BulkAssignMaterialVendorMutationHookResult = ReturnType<typeof useBulkAssignMaterialVendorMutation>;
export type BulkAssignMaterialVendorMutationResult = Apollo.MutationResult<BulkAssignMaterialVendorMutation>;
export type BulkAssignMaterialVendorMutationOptions = Apollo.BaseMutationOptions<BulkAssignMaterialVendorMutation, BulkAssignMaterialVendorMutationVariables>;
export const BulkSetMasterMaterialDefaultsDocument = gql`
    mutation BulkSetMasterMaterialDefaults($input: BulkSetMasterMaterialVendorsInputDTO!) {
  bulkSetMasterMaterialDefaults(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type BulkSetMasterMaterialDefaultsMutationFn = Apollo.MutationFunction<BulkSetMasterMaterialDefaultsMutation, BulkSetMasterMaterialDefaultsMutationVariables>;

/**
 * __useBulkSetMasterMaterialDefaultsMutation__
 *
 * To run a mutation, you first call `useBulkSetMasterMaterialDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetMasterMaterialDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetMasterMaterialDefaultsMutation, { data, loading, error }] = useBulkSetMasterMaterialDefaultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkSetMasterMaterialDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetMasterMaterialDefaultsMutation, BulkSetMasterMaterialDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSetMasterMaterialDefaultsMutation, BulkSetMasterMaterialDefaultsMutationVariables>(BulkSetMasterMaterialDefaultsDocument, options);
      }
export type BulkSetMasterMaterialDefaultsMutationHookResult = ReturnType<typeof useBulkSetMasterMaterialDefaultsMutation>;
export type BulkSetMasterMaterialDefaultsMutationResult = Apollo.MutationResult<BulkSetMasterMaterialDefaultsMutation>;
export type BulkSetMasterMaterialDefaultsMutationOptions = Apollo.BaseMutationOptions<BulkSetMasterMaterialDefaultsMutation, BulkSetMasterMaterialDefaultsMutationVariables>;
export const GetOrderActivityLogDocument = gql`
    query GetOrderActivityLog($input: OrderActivityLogInputDTO!) {
  orderActivityLog(input: $input) {
    id
    entityType
    action
    changes
    summary
    performedBy {
      id
      name
    }
    createdAt
    eventName
  }
}
    `;

/**
 * __useGetOrderActivityLogQuery__
 *
 * To run a query within a React component, call `useGetOrderActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderActivityLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables> & ({ variables: GetOrderActivityLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>(GetOrderActivityLogDocument, options);
      }
export function useGetOrderActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>(GetOrderActivityLogDocument, options);
        }
// @ts-ignore
export function useGetOrderActivityLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>;
export function useGetOrderActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderActivityLogQuery | undefined, GetOrderActivityLogQueryVariables>;
export function useGetOrderActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>(GetOrderActivityLogDocument, options);
        }
export type GetOrderActivityLogQueryHookResult = ReturnType<typeof useGetOrderActivityLogQuery>;
export type GetOrderActivityLogLazyQueryHookResult = ReturnType<typeof useGetOrderActivityLogLazyQuery>;
export type GetOrderActivityLogSuspenseQueryHookResult = ReturnType<typeof useGetOrderActivityLogSuspenseQuery>;
export type GetOrderActivityLogQueryResult = Apollo.QueryResult<GetOrderActivityLogQuery, GetOrderActivityLogQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($filters: OrdersFiltersInputDTO!, $pagination: PaginationInputDTO!) {
  orders(filters: $filters, pagination: $pagination) {
    edges {
      id
      name
      number
      startDate
      startTime
      endDate
      endTime
      status
      totalEvents
      customer {
        id
        name
        contactNo
        address
      }
    }
    pageInfo {
      totalCount
      limit
      offset
      totalEdges
    }
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables> & ({ variables: GetOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
// @ts-ignore
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersQuery | undefined, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOrderWithEventsDocument = gql`
    query GetOrderWithEvents($id: UUID!) {
  order(id: $id) {
    id
    name
    number
    startDate
    startTime
    endDate
    endTime
    status
    customer {
      id
      name
      contactNo
      address
    }
    events {
      id
      name
      address
      date
      time
      notes
      pax
      rate
      status
      totalMenuItems
    }
  }
}
    `;

/**
 * __useGetOrderWithEventsQuery__
 *
 * To run a query within a React component, call `useGetOrderWithEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderWithEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderWithEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderWithEventsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables> & ({ variables: GetOrderWithEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>(GetOrderWithEventsDocument, options);
      }
export function useGetOrderWithEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>(GetOrderWithEventsDocument, options);
        }
// @ts-ignore
export function useGetOrderWithEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>;
export function useGetOrderWithEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderWithEventsQuery | undefined, GetOrderWithEventsQueryVariables>;
export function useGetOrderWithEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>(GetOrderWithEventsDocument, options);
        }
export type GetOrderWithEventsQueryHookResult = ReturnType<typeof useGetOrderWithEventsQuery>;
export type GetOrderWithEventsLazyQueryHookResult = ReturnType<typeof useGetOrderWithEventsLazyQuery>;
export type GetOrderWithEventsSuspenseQueryHookResult = ReturnType<typeof useGetOrderWithEventsSuspenseQuery>;
export type GetOrderWithEventsQueryResult = Apollo.QueryResult<GetOrderWithEventsQuery, GetOrderWithEventsQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInputDTO!) {
  createOrder(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
    customerId
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInputDTO!) {
  updateOrder(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation UpdateOrderStatus($input: UpdateOrderStatusInputDTO!) {
  updateOrderStatus(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, options);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const GenerateEventsItemsPdfDocument = gql`
    mutation GenerateEventsItemsPDF($input: EventsItemsPDFGenerationInputDTO!) {
  generateEventsItemsPDF(input: $input) {
    events {
      eventId
      filename
      path
    }
    totalEvents
  }
}
    `;
export type GenerateEventsItemsPdfMutationFn = Apollo.MutationFunction<GenerateEventsItemsPdfMutation, GenerateEventsItemsPdfMutationVariables>;

/**
 * __useGenerateEventsItemsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateEventsItemsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEventsItemsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEventsItemsPdfMutation, { data, loading, error }] = useGenerateEventsItemsPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEventsItemsPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEventsItemsPdfMutation, GenerateEventsItemsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEventsItemsPdfMutation, GenerateEventsItemsPdfMutationVariables>(GenerateEventsItemsPdfDocument, options);
      }
export type GenerateEventsItemsPdfMutationHookResult = ReturnType<typeof useGenerateEventsItemsPdfMutation>;
export type GenerateEventsItemsPdfMutationResult = Apollo.MutationResult<GenerateEventsItemsPdfMutation>;
export type GenerateEventsItemsPdfMutationOptions = Apollo.BaseMutationOptions<GenerateEventsItemsPdfMutation, GenerateEventsItemsPdfMutationVariables>;
export const GenerateManagerEventsPdfDocument = gql`
    mutation GenerateManagerEventsPDF($input: ManagerEventsPDFGenerationInputDTO!) {
  generateManagerEventsPDF(input: $input) {
    events {
      eventId
      filename
      path
    }
    totalEvents
  }
}
    `;
export type GenerateManagerEventsPdfMutationFn = Apollo.MutationFunction<GenerateManagerEventsPdfMutation, GenerateManagerEventsPdfMutationVariables>;

/**
 * __useGenerateManagerEventsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateManagerEventsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateManagerEventsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateManagerEventsPdfMutation, { data, loading, error }] = useGenerateManagerEventsPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateManagerEventsPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateManagerEventsPdfMutation, GenerateManagerEventsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateManagerEventsPdfMutation, GenerateManagerEventsPdfMutationVariables>(GenerateManagerEventsPdfDocument, options);
      }
export type GenerateManagerEventsPdfMutationHookResult = ReturnType<typeof useGenerateManagerEventsPdfMutation>;
export type GenerateManagerEventsPdfMutationResult = Apollo.MutationResult<GenerateManagerEventsPdfMutation>;
export type GenerateManagerEventsPdfMutationOptions = Apollo.BaseMutationOptions<GenerateManagerEventsPdfMutation, GenerateManagerEventsPdfMutationVariables>;
export const GenerateEventsItemsMaterialsPdfDocument = gql`
    mutation GenerateEventsItemsMaterialsPDF($input: MaterialsEventsPDFGenerationInputDTO!) {
  generateEventsItemsMaterialsPDF(input: $input) {
    events {
      eventId
      filename
      path
    }
    totalEvents
  }
}
    `;
export type GenerateEventsItemsMaterialsPdfMutationFn = Apollo.MutationFunction<GenerateEventsItemsMaterialsPdfMutation, GenerateEventsItemsMaterialsPdfMutationVariables>;

/**
 * __useGenerateEventsItemsMaterialsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateEventsItemsMaterialsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEventsItemsMaterialsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEventsItemsMaterialsPdfMutation, { data, loading, error }] = useGenerateEventsItemsMaterialsPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEventsItemsMaterialsPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEventsItemsMaterialsPdfMutation, GenerateEventsItemsMaterialsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEventsItemsMaterialsPdfMutation, GenerateEventsItemsMaterialsPdfMutationVariables>(GenerateEventsItemsMaterialsPdfDocument, options);
      }
export type GenerateEventsItemsMaterialsPdfMutationHookResult = ReturnType<typeof useGenerateEventsItemsMaterialsPdfMutation>;
export type GenerateEventsItemsMaterialsPdfMutationResult = Apollo.MutationResult<GenerateEventsItemsMaterialsPdfMutation>;
export type GenerateEventsItemsMaterialsPdfMutationOptions = Apollo.BaseMutationOptions<GenerateEventsItemsMaterialsPdfMutation, GenerateEventsItemsMaterialsPdfMutationVariables>;
export const GenerateEventItemsLabelsPdfDocument = gql`
    mutation GenerateEventItemsLabelsPDF($input: EventItemsLabelsPDFGenerationInputDTO!) {
  generateEventItemsLabelsPDF(input: $input) {
    filename
    path
  }
}
    `;
export type GenerateEventItemsLabelsPdfMutationFn = Apollo.MutationFunction<GenerateEventItemsLabelsPdfMutation, GenerateEventItemsLabelsPdfMutationVariables>;

/**
 * __useGenerateEventItemsLabelsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateEventItemsLabelsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEventItemsLabelsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEventItemsLabelsPdfMutation, { data, loading, error }] = useGenerateEventItemsLabelsPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEventItemsLabelsPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEventItemsLabelsPdfMutation, GenerateEventItemsLabelsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEventItemsLabelsPdfMutation, GenerateEventItemsLabelsPdfMutationVariables>(GenerateEventItemsLabelsPdfDocument, options);
      }
export type GenerateEventItemsLabelsPdfMutationHookResult = ReturnType<typeof useGenerateEventItemsLabelsPdfMutation>;
export type GenerateEventItemsLabelsPdfMutationResult = Apollo.MutationResult<GenerateEventItemsLabelsPdfMutation>;
export type GenerateEventItemsLabelsPdfMutationOptions = Apollo.BaseMutationOptions<GenerateEventItemsLabelsPdfMutation, GenerateEventItemsLabelsPdfMutationVariables>;
export const GenerateMenuItemVendorReportsDocument = gql`
    mutation GenerateMenuItemVendorReports($input: GenerateMenuItemVendorReportsInputDTO!) {
  generateMenuItemVendorReports(input: $input) {
    vendors {
      vendorId
      vendorName
      path
      filename
    }
    totalVendors
  }
}
    `;
export type GenerateMenuItemVendorReportsMutationFn = Apollo.MutationFunction<GenerateMenuItemVendorReportsMutation, GenerateMenuItemVendorReportsMutationVariables>;

/**
 * __useGenerateMenuItemVendorReportsMutation__
 *
 * To run a mutation, you first call `useGenerateMenuItemVendorReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMenuItemVendorReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMenuItemVendorReportsMutation, { data, loading, error }] = useGenerateMenuItemVendorReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMenuItemVendorReportsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMenuItemVendorReportsMutation, GenerateMenuItemVendorReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMenuItemVendorReportsMutation, GenerateMenuItemVendorReportsMutationVariables>(GenerateMenuItemVendorReportsDocument, options);
      }
export type GenerateMenuItemVendorReportsMutationHookResult = ReturnType<typeof useGenerateMenuItemVendorReportsMutation>;
export type GenerateMenuItemVendorReportsMutationResult = Apollo.MutationResult<GenerateMenuItemVendorReportsMutation>;
export type GenerateMenuItemVendorReportsMutationOptions = Apollo.BaseMutationOptions<GenerateMenuItemVendorReportsMutation, GenerateMenuItemVendorReportsMutationVariables>;
export const GenerateMaterialVendorReportsDocument = gql`
    mutation GenerateMaterialVendorReports($input: GenerateMaterialVendorReportsInputDTO!) {
  generateMaterialVendorReports(input: $input) {
    vendors {
      vendorId
      vendorName
      path
      filename
    }
    totalVendors
  }
}
    `;
export type GenerateMaterialVendorReportsMutationFn = Apollo.MutationFunction<GenerateMaterialVendorReportsMutation, GenerateMaterialVendorReportsMutationVariables>;

/**
 * __useGenerateMaterialVendorReportsMutation__
 *
 * To run a mutation, you first call `useGenerateMaterialVendorReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMaterialVendorReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMaterialVendorReportsMutation, { data, loading, error }] = useGenerateMaterialVendorReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMaterialVendorReportsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMaterialVendorReportsMutation, GenerateMaterialVendorReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMaterialVendorReportsMutation, GenerateMaterialVendorReportsMutationVariables>(GenerateMaterialVendorReportsDocument, options);
      }
export type GenerateMaterialVendorReportsMutationHookResult = ReturnType<typeof useGenerateMaterialVendorReportsMutation>;
export type GenerateMaterialVendorReportsMutationResult = Apollo.MutationResult<GenerateMaterialVendorReportsMutation>;
export type GenerateMaterialVendorReportsMutationOptions = Apollo.BaseMutationOptions<GenerateMaterialVendorReportsMutation, GenerateMaterialVendorReportsMutationVariables>;
export const GetEventTemplateSummariesDocument = gql`
    query GetEventTemplateSummaries {
  eventTemplateSummaries {
    id
    name
    description
    suggestionCriteria
    rate
    isActive
    itemCount
    categoryCount
  }
}
    `;

/**
 * __useGetEventTemplateSummariesQuery__
 *
 * To run a query within a React component, call `useGetEventTemplateSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTemplateSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTemplateSummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventTemplateSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>(GetEventTemplateSummariesDocument, options);
      }
export function useGetEventTemplateSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>(GetEventTemplateSummariesDocument, options);
        }
// @ts-ignore
export function useGetEventTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>;
export function useGetEventTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventTemplateSummariesQuery | undefined, GetEventTemplateSummariesQueryVariables>;
export function useGetEventTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>(GetEventTemplateSummariesDocument, options);
        }
export type GetEventTemplateSummariesQueryHookResult = ReturnType<typeof useGetEventTemplateSummariesQuery>;
export type GetEventTemplateSummariesLazyQueryHookResult = ReturnType<typeof useGetEventTemplateSummariesLazyQuery>;
export type GetEventTemplateSummariesSuspenseQueryHookResult = ReturnType<typeof useGetEventTemplateSummariesSuspenseQuery>;
export type GetEventTemplateSummariesQueryResult = Apollo.QueryResult<GetEventTemplateSummariesQuery, GetEventTemplateSummariesQueryVariables>;
export const GetEventTemplateDocument = gql`
    query GetEventTemplate($id: UUID!) {
  eventTemplate(id: $id) {
    id
    name
    description
    suggestionCriteria
    rate
    isActive
    categories {
      masterCategory {
        id
        name
        sequence
        type
        groupId
        groupName
        isInternal
        showCategoryLabel
      }
      templateItems {
        id
        masterItem {
          id
          name
          sequence
          isExtraChargeable
          isExtraByDefault
          defaultExtraRate
        }
        alternativeGroupId
        groupPickCount
      }
    }
  }
}
    `;

/**
 * __useGetEventTemplateQuery__
 *
 * To run a query within a React component, call `useGetEventTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEventTemplateQuery, GetEventTemplateQueryVariables> & ({ variables: GetEventTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTemplateQuery, GetEventTemplateQueryVariables>(GetEventTemplateDocument, options);
      }
export function useGetEventTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTemplateQuery, GetEventTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTemplateQuery, GetEventTemplateQueryVariables>(GetEventTemplateDocument, options);
        }
// @ts-ignore
export function useGetEventTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventTemplateQuery, GetEventTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventTemplateQuery, GetEventTemplateQueryVariables>;
export function useGetEventTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTemplateQuery, GetEventTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventTemplateQuery | undefined, GetEventTemplateQueryVariables>;
export function useGetEventTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTemplateQuery, GetEventTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTemplateQuery, GetEventTemplateQueryVariables>(GetEventTemplateDocument, options);
        }
export type GetEventTemplateQueryHookResult = ReturnType<typeof useGetEventTemplateQuery>;
export type GetEventTemplateLazyQueryHookResult = ReturnType<typeof useGetEventTemplateLazyQuery>;
export type GetEventTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEventTemplateSuspenseQuery>;
export type GetEventTemplateQueryResult = Apollo.QueryResult<GetEventTemplateQuery, GetEventTemplateQueryVariables>;
export const GetSuggestedTemplatesDocument = gql`
    query GetSuggestedTemplates($eventName: String!, $pax: Int, $rate: Int) {
  suggestedTemplates(eventName: $eventName, pax: $pax, rate: $rate) {
    id
    name
    description
    suggestionCriteria
    rate
    isActive
    itemCount
    categoryCount
  }
}
    `;

/**
 * __useGetSuggestedTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedTemplatesQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      pax: // value for 'pax'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useGetSuggestedTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables> & ({ variables: GetSuggestedTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>(GetSuggestedTemplatesDocument, options);
      }
export function useGetSuggestedTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>(GetSuggestedTemplatesDocument, options);
        }
// @ts-ignore
export function useGetSuggestedTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>;
export function useGetSuggestedTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuggestedTemplatesQuery | undefined, GetSuggestedTemplatesQueryVariables>;
export function useGetSuggestedTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>(GetSuggestedTemplatesDocument, options);
        }
export type GetSuggestedTemplatesQueryHookResult = ReturnType<typeof useGetSuggestedTemplatesQuery>;
export type GetSuggestedTemplatesLazyQueryHookResult = ReturnType<typeof useGetSuggestedTemplatesLazyQuery>;
export type GetSuggestedTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedTemplatesSuspenseQuery>;
export type GetSuggestedTemplatesQueryResult = Apollo.QueryResult<GetSuggestedTemplatesQuery, GetSuggestedTemplatesQueryVariables>;
export const CreateEventTemplateDocument = gql`
    mutation CreateEventTemplate($input: CreateEventTemplateInputDTO!) {
  createEventTemplate(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateEventTemplateMutationFn = Apollo.MutationFunction<CreateEventTemplateMutation, CreateEventTemplateMutationVariables>;

/**
 * __useCreateEventTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventTemplateMutation, { data, loading, error }] = useCreateEventTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventTemplateMutation, CreateEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventTemplateMutation, CreateEventTemplateMutationVariables>(CreateEventTemplateDocument, options);
      }
export type CreateEventTemplateMutationHookResult = ReturnType<typeof useCreateEventTemplateMutation>;
export type CreateEventTemplateMutationResult = Apollo.MutationResult<CreateEventTemplateMutation>;
export type CreateEventTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEventTemplateMutation, CreateEventTemplateMutationVariables>;
export const UpdateEventTemplateDocument = gql`
    mutation UpdateEventTemplate($input: UpdateEventTemplateInputDTO!) {
  updateEventTemplate(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type UpdateEventTemplateMutationFn = Apollo.MutationFunction<UpdateEventTemplateMutation, UpdateEventTemplateMutationVariables>;

/**
 * __useUpdateEventTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventTemplateMutation, { data, loading, error }] = useUpdateEventTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTemplateMutation, UpdateEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTemplateMutation, UpdateEventTemplateMutationVariables>(UpdateEventTemplateDocument, options);
      }
export type UpdateEventTemplateMutationHookResult = ReturnType<typeof useUpdateEventTemplateMutation>;
export type UpdateEventTemplateMutationResult = Apollo.MutationResult<UpdateEventTemplateMutation>;
export type UpdateEventTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEventTemplateMutation, UpdateEventTemplateMutationVariables>;
export const SetEventTemplateItemsDocument = gql`
    mutation SetEventTemplateItems($input: SetEventTemplateItemsInputDTO!) {
  setEventTemplateItems(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type SetEventTemplateItemsMutationFn = Apollo.MutationFunction<SetEventTemplateItemsMutation, SetEventTemplateItemsMutationVariables>;

/**
 * __useSetEventTemplateItemsMutation__
 *
 * To run a mutation, you first call `useSetEventTemplateItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventTemplateItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventTemplateItemsMutation, { data, loading, error }] = useSetEventTemplateItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEventTemplateItemsMutation(baseOptions?: Apollo.MutationHookOptions<SetEventTemplateItemsMutation, SetEventTemplateItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEventTemplateItemsMutation, SetEventTemplateItemsMutationVariables>(SetEventTemplateItemsDocument, options);
      }
export type SetEventTemplateItemsMutationHookResult = ReturnType<typeof useSetEventTemplateItemsMutation>;
export type SetEventTemplateItemsMutationResult = Apollo.MutationResult<SetEventTemplateItemsMutation>;
export type SetEventTemplateItemsMutationOptions = Apollo.BaseMutationOptions<SetEventTemplateItemsMutation, SetEventTemplateItemsMutationVariables>;
export const DeleteEventTemplateDocument = gql`
    mutation DeleteEventTemplate($id: UUID!) {
  deleteEventTemplate(id: $id) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type DeleteEventTemplateMutationFn = Apollo.MutationFunction<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>;

/**
 * __useDeleteEventTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventTemplateMutation, { data, loading, error }] = useDeleteEventTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>(DeleteEventTemplateDocument, options);
      }
export type DeleteEventTemplateMutationHookResult = ReturnType<typeof useDeleteEventTemplateMutation>;
export type DeleteEventTemplateMutationResult = Apollo.MutationResult<DeleteEventTemplateMutation>;
export type DeleteEventTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEventTemplateMutation, DeleteEventTemplateMutationVariables>;
export const GenerateEventTemplatePdfDocument = gql`
    mutation GenerateEventTemplatePDF($input: EventTemplatePDFGenerationInputDTO!) {
  generateEventTemplatePDF(input: $input) {
    filename
    path
  }
}
    `;
export type GenerateEventTemplatePdfMutationFn = Apollo.MutationFunction<GenerateEventTemplatePdfMutation, GenerateEventTemplatePdfMutationVariables>;

/**
 * __useGenerateEventTemplatePdfMutation__
 *
 * To run a mutation, you first call `useGenerateEventTemplatePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEventTemplatePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEventTemplatePdfMutation, { data, loading, error }] = useGenerateEventTemplatePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEventTemplatePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEventTemplatePdfMutation, GenerateEventTemplatePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEventTemplatePdfMutation, GenerateEventTemplatePdfMutationVariables>(GenerateEventTemplatePdfDocument, options);
      }
export type GenerateEventTemplatePdfMutationHookResult = ReturnType<typeof useGenerateEventTemplatePdfMutation>;
export type GenerateEventTemplatePdfMutationResult = Apollo.MutationResult<GenerateEventTemplatePdfMutation>;
export type GenerateEventTemplatePdfMutationOptions = Apollo.BaseMutationOptions<GenerateEventTemplatePdfMutation, GenerateEventTemplatePdfMutationVariables>;
export const GetMasterVendorsDocument = gql`
    query GetMasterVendors {
  vendors {
    id
    name
    contactNo
    scopeOfWork
  }
}
    `;

/**
 * __useGetMasterVendorsQuery__
 *
 * To run a query within a React component, call `useGetMasterVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>(GetMasterVendorsDocument, options);
      }
export function useGetMasterVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>(GetMasterVendorsDocument, options);
        }
// @ts-ignore
export function useGetMasterVendorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>;
export function useGetMasterVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasterVendorsQuery | undefined, GetMasterVendorsQueryVariables>;
export function useGetMasterVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>(GetMasterVendorsDocument, options);
        }
export type GetMasterVendorsQueryHookResult = ReturnType<typeof useGetMasterVendorsQuery>;
export type GetMasterVendorsLazyQueryHookResult = ReturnType<typeof useGetMasterVendorsLazyQuery>;
export type GetMasterVendorsSuspenseQueryHookResult = ReturnType<typeof useGetMasterVendorsSuspenseQuery>;
export type GetMasterVendorsQueryResult = Apollo.QueryResult<GetMasterVendorsQuery, GetMasterVendorsQueryVariables>;
export const CreateVendorDocument = gql`
    mutation CreateVendor($input: CreateVendorInputDTO!) {
  createVendor(input: $input) {
    operationInfo {
      success
      message
      code
    }
    id
  }
}
    `;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($input: UpdateVendorInputDTO!) {
  updateVendor(input: $input) {
    operationInfo {
      success
      message
      code
    }
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;